(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $f96a28a13e717e1b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $1db7531ccf6877e4$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $481e3fc5cb8b7392$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $20fa4ac5e52864a2$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $552f1931c107dd10$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $20fa4ac5e52864a2$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $20fa4ac5e52864a2$export$71511d61b312f219)(o, minLen);
}


function $595c5a81428bb48a$export$71511d61b312f219(arr, i) {
    return (0, $f96a28a13e717e1b$export$71511d61b312f219)(arr) || (0, $1db7531ccf6877e4$export$71511d61b312f219)(arr, i) || (0, $552f1931c107dd10$export$71511d61b312f219)(arr, i) || (0, $481e3fc5cb8b7392$export$71511d61b312f219)();
}


function $cbe0397808b0ae7d$export$85fae2512280f40b(theme, lang) {
    if (!("fetch" in window)) return;
    return fetch("".concat(window.BH_URL, "/api/widget-enabled?rootTheme=").concat(theme, "&theme=").concat(theme, "&lang=").concat(lang));
}


var $2f23a94a28b6e759$exports = {};
(function(global, factory) {
    $2f23a94a28b6e759$exports = factory();
})($2f23a94a28b6e759$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


function $68c4eca8780e0866$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $68c4eca8780e0866$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $68c4eca8780e0866$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $68c4eca8780e0866$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $0516e5fd92d6f0f4$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $71c98a0c5b40ff86$var$extendStatics = function extendStatics1(d, b) {
    $71c98a0c5b40ff86$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $71c98a0c5b40ff86$var$extendStatics(d, b);
};
function $71c98a0c5b40ff86$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $71c98a0c5b40ff86$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $71c98a0c5b40ff86$export$18ce0697a983be9b = function __assign1() {
    $71c98a0c5b40ff86$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71c98a0c5b40ff86$export$18ce0697a983be9b.apply(this, arguments);
};
function $71c98a0c5b40ff86$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $71c98a0c5b40ff86$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $71c98a0c5b40ff86$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $71c98a0c5b40ff86$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $71c98a0c5b40ff86$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $71c98a0c5b40ff86$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0516e5fd92d6f0f4$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $71c98a0c5b40ff86$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0516e5fd92d6f0f4$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $71c98a0c5b40ff86$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $71c98a0c5b40ff86$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $71c98a0c5b40ff86$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $71c98a0c5b40ff86$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $71c98a0c5b40ff86$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $71c98a0c5b40ff86$export$45d3717a4c69092e(o, m, p);
}
function $71c98a0c5b40ff86$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $71c98a0c5b40ff86$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $71c98a0c5b40ff86$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($71c98a0c5b40ff86$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $71c98a0c5b40ff86$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $71c98a0c5b40ff86$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $71c98a0c5b40ff86$export$10c90e4f7922046c(v) {
    return this instanceof $71c98a0c5b40ff86$export$10c90e4f7922046c ? (this.v = v, this) : new $71c98a0c5b40ff86$export$10c90e4f7922046c(v);
}
function $71c98a0c5b40ff86$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $71c98a0c5b40ff86$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $71c98a0c5b40ff86$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $71c98a0c5b40ff86$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $71c98a0c5b40ff86$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $71c98a0c5b40ff86$export$19a8beecd37a4c45 === "function" ? $71c98a0c5b40ff86$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $71c98a0c5b40ff86$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $71c98a0c5b40ff86$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $71c98a0c5b40ff86$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $71c98a0c5b40ff86$export$45d3717a4c69092e(result, mod, k);
    }
    $71c98a0c5b40ff86$var$__setModuleDefault(result, mod);
    return result;
}
function $71c98a0c5b40ff86$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $71c98a0c5b40ff86$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $71c98a0c5b40ff86$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $71c98a0c5b40ff86$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $71c98a0c5b40ff86$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $71c98a0c5b40ff86$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $71c98a0c5b40ff86$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $71c98a0c5b40ff86$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $71c98a0c5b40ff86$export$2e2bcd8739ae039 = {
    __extends: $71c98a0c5b40ff86$export$a8ba968b8961cb8a,
    __assign: $71c98a0c5b40ff86$export$18ce0697a983be9b,
    __rest: $71c98a0c5b40ff86$export$3c9a16f847548506,
    __decorate: $71c98a0c5b40ff86$export$29e00dfd3077644b,
    __param: $71c98a0c5b40ff86$export$d5ad3fd78186038f,
    __metadata: $71c98a0c5b40ff86$export$f1db080c865becb9,
    __awaiter: $71c98a0c5b40ff86$export$1050f835b63b671e,
    __generator: $71c98a0c5b40ff86$export$67ebef60e6f28a6,
    __createBinding: $71c98a0c5b40ff86$export$45d3717a4c69092e,
    __exportStar: $71c98a0c5b40ff86$export$f33643c0debef087,
    __values: $71c98a0c5b40ff86$export$19a8beecd37a4c45,
    __read: $71c98a0c5b40ff86$export$8d051b38c9118094,
    __spread: $71c98a0c5b40ff86$export$afc72e2116322959,
    __spreadArrays: $71c98a0c5b40ff86$export$6388937ca91ccae8,
    __spreadArray: $71c98a0c5b40ff86$export$1216008129fb82ed,
    __await: $71c98a0c5b40ff86$export$10c90e4f7922046c,
    __asyncGenerator: $71c98a0c5b40ff86$export$e427f37a30a4de9b,
    __asyncDelegator: $71c98a0c5b40ff86$export$bbd80228419bb833,
    __asyncValues: $71c98a0c5b40ff86$export$e3b29a3d6162315f,
    __makeTemplateObject: $71c98a0c5b40ff86$export$4fb47efe1390b86f,
    __importStar: $71c98a0c5b40ff86$export$c21735bcef00d192,
    __importDefault: $71c98a0c5b40ff86$export$da59b14a69baef04,
    __classPrivateFieldGet: $71c98a0c5b40ff86$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $71c98a0c5b40ff86$export$d40a35129aaff81f,
    __classPrivateFieldIn: $71c98a0c5b40ff86$export$81fdc39f203e4e04,
    __addDisposableResource: $71c98a0c5b40ff86$export$88ac25d8e944e405,
    __disposeResources: $71c98a0c5b40ff86$export$8f076105dc360e92
};



var $0b748888cf77b1cd$export$92a206f25e973e57 = '\n  <svg\n    class="beratungshero--icon"\n    viewBox="0 0 20 20"\n    xmlns="http://www.w3.org/2000/svg"\n  >\n    <path\n      d="M1.498 19.802a.75.75 0 0 1-.996-1.122l18-15.99a.75.75 0 0 1 .996 1.12l-18 15.992zM16.953 8.078a6.966 6.966 0 0 1-1.241 3.055l.824.235C19.19 12.127 20 14.545 20 15.961v1.003A3.04 3.04 0 0 1 16.964 20H3.534l2.11-1.875h11.32c.641 0 1.161-.52 1.161-1.16V15.96a2.902 2.902 0 0 0-2.105-2.79l-1.8-.515a7.013 7.013 0 0 1-4 1.403l6.733-5.98zm-1.141-5.005l-1.418 1.26a5.156 5.156 0 1 0-7.592 6.744l-2.137 1.898-.685.196a2.902 2.902 0 0 0-2.052 2.236l-1.924 1.71A3.071 3.071 0 0 1 0 16.963v-1.003c0-1.446.831-3.84 3.464-4.593l.824-.235a7.01 7.01 0 0 1-1.32-4.102 7.03 7.03 0 0 1 12.844-3.958z"\n      fillRule="nonzero"\n    />\n  </svg>\n';
var $0b748888cf77b1cd$export$8360e631d277ea4d = '<svg width="10px" height="10px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <g id="CloseWidget" stroke="none" stroke-width="1" fill-rule="evenodd">\n        <path d="M10,8.85231025 L18.6292049,0.233566186 C18.9466023,-0.0834464214 19.4572997,-0.0796864741 19.7698794,0.241964263 C20.0824591,0.563615001 20.0785537,1.08135394 19.7611563,1.39836655 L11.1490827,10 L19.7611563,18.6016335 C20.0785537,18.9186461 20.0824591,19.436385 19.7698794,19.7580357 C19.4572997,20.0796865 18.9466023,20.0834464 18.6292049,19.7664338 L10,11.1476898 L1.37079506,19.7664338 C1.05339769,20.0834464 0.54270033,20.0796865 0.230120591,19.7580357 C-0.0824591484,19.436385 -0.0785536815,18.9186461 0.238843695,18.6016335 L8.85091726,10 L0.238843695,1.39836655 C-0.0785536815,1.08135394 -0.0824591484,0.563615001 0.230120591,0.241964263 C0.54270033,-0.0796864741 1.05339769,-0.0834464214 1.37079506,0.233566186 L10,8.85231025 Z" id="Combined-Shape" fill-rule="nonzero"></path>\n    </g>\n</svg>';
var $0b748888cf77b1cd$export$530dccc8e24f4e99 = '\n  <svg\n    class="beratungshero--icon"\n    viewBox="0 0 27 24"\n    xmlns="http://www.w3.org/2000/svg"\n  >\n    <g fill-rule="nonzero">\n      <path d="M3 17a3 3 0 01-3-3V3a3 3 0 013-3h21a3 3 0 013 3v11a3 3 0 01-3 3H11.362L4 23.135V17H3zm7.638-2H24a1 1 0 001-1V3a1 1 0 00-1-1H3a1 1 0 00-1 1v11a1 1 0 001 1h3v3.865L10.638 15z"/><path d="M6 7h15a1 1 0 000-2H6a1 1 0 100 2zM6 11h8a1 1 0 000-2H6a1 1 0 100 2z"/>\n    </g>\n  </svg>\n';
var $0b748888cf77b1cd$export$5f8d3589eb8441ca = '\n  <svg class="beratungshero--icon" viewBox="0 0 27 19" xmlns="http://www.w3.org/2000/svg">\n    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n      <path d="M18.6666667,15.765625 C18.6666667,17.4801384 17.2890255,18.875 15.5833333,18.875 L3.08333333,18.875 C1.37764112,18.875 0,17.4801384 0,15.765625 L0,3.109375 C0,1.39486164 1.37764112,0 3.08333333,0 L15.5833333,0 C17.2890255,0 18.6666667,1.39486164 18.6666667,3.109375 L18.6666667,3.48629515 L21.2060905,0.91512852 C21.7843415,0.329645025 22.5703373,0 23.3907118,0 L23.9166667,0 C25.6223589,0 27,1.39486164 27,3.109375 L27,15.765625 C27,17.4801384 25.6223589,18.875 23.9166667,18.875 L23.3907118,18.875 C22.5703373,18.875 21.7843415,18.545355 21.2060931,17.9598741 L18.6666667,15.3887048 L18.6666667,15.765625 Z M3.08333333,2 C2.48781027,2 2,2.49390789 2,3.109375 L2,15.765625 C2,16.3810921 2.48781027,16.875 3.08333333,16.875 L15.5833333,16.875 C16.1788564,16.875 16.6666667,16.3810921 16.6666667,15.765625 L16.6666667,10.5175452 L22.6290657,16.5544742 C22.8322155,16.7601648 23.106025,16.875 23.3907118,16.875 L23.9166667,16.875 C24.5121897,16.875 25,16.3810921 25,15.765625 L25,3.109375 C25,2.49390789 24.5121897,2 23.9166667,2 L23.3907118,2 C23.106025,2 22.8322155,2.11483516 22.6290631,2.32052841 L16.6666667,8.35745485 L16.6666667,3.109375 C16.6666667,2.49390789 16.1788564,2 15.5833333,2 L3.08333333,2 Z" id="video" fill="#fff" fill-rule="nonzero"></path>\n    </g>\n  </svg>';
var $0b748888cf77b1cd$export$ead18583963a4390 = '\n  <svg\n      class="beratungshero--icon"\n      viewBox="0 0 103 97"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        d="M7.087 1.456l.13.168 65.35 88.485a4 4 0 01-6.305 4.92l-.131-.167L.783 6.377a4 4 0 016.304-4.92zm95.893 20.938l.013.25.007.366v50c0 7.391-8.39 11.585-14.337 7.244l-.2-.15-.224-.18-10.313-8.594-.02.185a11.999 11.999 0 01-5.317 8.526l-4.775-6.465a4 4 0 002.18-3.345L70 70.01v-15.7L93.3 73.73l.102.083c.614.472 1.513.067 1.593-.692l.006-.11V23.088l-.004-.14-.008-.1c-.098-.666-.846-1.034-1.438-.733l-.102.06-.089.067L70 41.707V26.01a4 4 0 00-3.8-3.995l-.2-.005H29.732l-5.908-8H66c6.016 0 10.998 4.426 11.866 10.2l.04.295.02.183 10.313-8.592c5.677-4.732 14.268-.973 14.741 6.298zM2.453 18.738L8 26.248V70.01a4 4 0 003.8 3.995l.2.005h31.274l5.908 8H12C5.475 82.01.166 76.801.004 70.315L0 70.01v-44c0-2.734.914-5.254 2.453-7.272z"\n        fillRule="nonzero"\n      />\n    </svg>\n  ';
var $0b748888cf77b1cd$export$fe475e7e7b6e281b = '\n  <svg class="beratungshero--icon" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M20 0H2C0.89 0 0 0.89 0 2V14C0 15.1 0.89 16 2 16H7V18H15V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.89 21.1 0 20 0ZM20 14H2V2H20V14ZM15 8L8 12V4L15 8Z" fill="currentColor" />\n  </svg>';
var $0b748888cf77b1cd$export$c3694a0927aa4b45 = '\n  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M2.17641 0L0 2.17761L6.72988 8.9112L6.28225 9.37452H0.108048V18.6409H6.28225L14 26.3629V16.1853L20.452 22.6409C19.4487 23.3977 18.3219 24 17.0871 24.3552V27.5367C19.1555 27.0734 21.054 26.1158 22.6593 24.834L25.8236 28L28 25.8224L2.17641 0ZM10.9129 18.9035L7.5634 15.5521H3.19515V12.4633H7.5634L8.92172 11.1042L10.9129 13.0965V18.9035ZM24.8049 14.0077C24.8049 15.2741 24.5733 16.4942 24.172 17.6216L26.5336 19.9846C27.398 18.1776 27.892 16.1544 27.892 14.0077C27.892 7.39768 23.2767 1.86873 17.0871 0.46332V3.64479C21.548 4.97297 24.8049 9.11197 24.8049 14.0077ZM14 1.65251L11.0981 4.55598L14 7.45946V1.65251ZM20.946 14.0077C20.946 11.2741 19.3716 8.92664 17.0871 7.78378V10.5483L20.9151 14.3784C20.9305 14.2548 20.946 14.1313 20.946 14.0077Z" fill="white"/>\n  </svg>';
var $0b748888cf77b1cd$export$d658018a9147579e = '\n  <svg class="beratungshero--icon" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5C0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z" fill="currentColor" />\n  </svg>';
var $0b748888cf77b1cd$export$9d7c7e61b1dce3b0 = '\n  <svg class="beratungshero--icon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M19 4.5L15 8.5V5C15 4.45 14.55 4 14 4H7.82L19 15.18V4.5ZM1.27 0L0 1.27L2.73 4H2C1.45 4 1 4.45 1 5V15C1 15.55 1.45 16 2 16H14C14.21 16 14.39 15.92 14.54 15.82L17.73 19L19 17.73L1.27 0Z" fill="currentColor" />\n  </svg>';
var $0b748888cf77b1cd$export$58ee0ea85d7a10b9 = '\n  <svg class="beratungshero--icon" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">\n          <g id="25---Wieder-kontaktieren-1" transform="translate(-262.000000, -370.000000)" fill-rule="nonzero">\n              <path d="M276.668192,370.721127 L273.621315,370.01809 C273.28985,369.941596 272.951031,370.113363 272.816939,370.426225 L271.410688,373.707389 C271.287287,373.995331 271.369264,374.330179 271.611723,374.528552 L273.387613,375.981561 C272.333716,378.227901 270.489037,380.09801 268.194768,381.174378 L266.741759,379.398517 C266.543386,379.156057 266.208538,379.07408 265.920596,379.197482 L262.639431,380.603733 C262.326658,380.737766 262.154773,381.076555 262.231296,381.408108 L262.934334,384.454986 C263.0074,384.771597 263.289793,385 263.619442,385 C271.121996,385 277.213202,378.919952 277.213202,371.406235 C277.213202,371.078813 276.987206,370.794721 276.668192,370.721127 Z" id="phone" transform="translate(269.713202, 377.499998) scale(1, -1) rotate(270.000000) translate(-269.713202, -377.499998) "></path>\n          </g>\n      </g>\n  </svg>\n  ';
var $0b748888cf77b1cd$export$56bbcdb8aca31149 = '\n  <svg class="beratungshero--icon-calendar" width="16px" height="18px" viewBox="0 0 16 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <title>icon/calendar</title>\n    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">\n        <g id="BH-Popup-Variante-D" transform="translate(-28.000000, -375.000000)">\n            <g id="Link_Termin" transform="translate(28.000000, 375.000000)">\n                <path d="M1.230769,16.7142859 L3.99999979,16.7142859 L3.99999979,13.8214286 L1.230769,13.8214286 L1.230769,16.7142859 Z M4.61538324,16.7142859 L7.6923068,16.7142859 L7.6923068,13.8214286 L4.61538324,13.8214286 L4.61538324,16.7142859 Z M1.230769,13.1785727 L3.99999979,13.1785727 L3.99999979,9.96428634 L1.230769,9.96428634 L1.230769,13.1785727 Z M4.61538324,13.1785727 L7.6923068,13.1785727 L7.6923068,9.96428634 L4.61538324,9.96428634 L4.61538324,13.1785727 Z M1.230769,9.32142732 L3.99999979,9.32142732 L3.99999979,6.42857268 L1.230769,6.42857268 L1.230769,9.32142732 Z M8.3076932,16.7142859 L11.3846168,16.7142859 L11.3846168,13.8214286 L8.3076932,13.8214286 L8.3076932,16.7142859 Z M4.61538324,9.32142732 L7.6923068,9.32142732 L7.6923068,6.42857268 L4.61538324,6.42857268 L4.61538324,9.32142732 Z M11.9999989,16.7142859 L14.7692314,16.7142859 L14.7692314,13.8214286 L11.9999989,13.8214286 L11.9999989,16.7142859 Z M8.3076932,13.1785727 L11.3846168,13.1785727 L11.3846168,9.96428634 L8.3076932,9.96428634 L8.3076932,13.1785727 Z M4.92307854,4.5 L4.92307854,1.60714098 C4.92307854,1.52008683 4.89262631,1.44475463 4.83173025,1.38114 C4.77083419,1.31752098 4.69871712,1.28571366 4.61538324,1.28571366 L3.99999979,1.28571366 C3.91666591,1.28571366 3.84455136,1.31752098 3.78365362,1.38114 C3.72275588,1.44475463 3.69230743,1.52008683 3.69230743,1.60714098 L3.69230743,4.5 C3.69230743,4.58705415 3.72275588,4.66238634 3.78365362,4.72600537 C3.84455136,4.78962 3.91666591,4.82142732 3.99999979,4.82142732 L4.61538324,4.82142732 C4.69871712,4.82142732 4.77083419,4.78962 4.83173025,4.72600537 C4.89262631,4.66238634 4.92307854,4.58705415 4.92307854,4.5 Z M11.9999989,13.1785727 L14.7692314,13.1785727 L14.7692314,9.96428634 L11.9999989,9.96428634 L11.9999989,13.1785727 Z M8.3076932,9.32142732 L11.3846168,9.32142732 L11.3846168,6.42857268 L8.3076932,6.42857268 L8.3076932,9.32142732 Z M11.9999989,9.32142732 L14.7692314,9.32142732 L14.7692314,6.42857268 L11.9999989,6.42857268 L11.9999989,9.32142732 Z M12.30769,4.5 L12.30769,1.60714098 C12.30769,1.52008683 12.277242,1.44475463 12.216346,1.38114 C12.1554499,1.31752098 12.0833328,1.28571366 11.9999989,1.28571366 L11.3846168,1.28571366 C11.3012829,1.28571366 11.2291658,1.31752098 11.1682697,1.38114 C11.1073695,1.44475463 11.0769215,1.52008683 11.0769215,1.60714098 L11.0769215,4.5 C11.0769215,4.58705415 11.1073695,4.66238634 11.1682697,4.72600537 C11.2291658,4.78962 11.3012829,4.82142732 11.3846168,4.82142732 L11.9999989,4.82142732 C12.0833328,4.82142732 12.1554499,4.78962 12.216346,4.72600537 C12.277242,4.66238634 12.30769,4.58705415 12.30769,4.5 Z M16,3.85714098 L16,16.7142859 C16,17.0625016 15.8782037,17.3638379 15.6346152,17.6183036 C15.3910226,17.8727692 15.1025669,18 14.7692314,18 L1.230769,18 C0.897434323,18 0.608975707,17.8727692 0.365384584,17.6183036 C0.121793628,17.3638379 0,17.0625016 0,16.7142859 L0,3.85714098 C0,3.50892878 0.121793628,3.20759122 0.365384584,2.9531239 C0.608975707,2.69866098 0.897434323,2.57142732 1.230769,2.57142732 L2.46153843,2.57142732 L2.46153843,1.60714098 C2.46153843,1.16517512 2.61217779,0.786832683 2.91346156,0.472096098 C3.21474492,0.157363902 3.57692096,0 4,0 L4.61538324,0 C5.03846165,0 5.4006398,0.157363902 5.70192189,0.472096098 C6.00320818,0.786832683 6.15384712,1.16517512 6.15384712,1.60714098 L6.15384712,2.57142732 L9.84615288,2.57142732 L9.84615288,1.60714098 C9.84615288,1.16517512 9.99679182,0.786832683 10.2980781,0.472096098 C10.5993602,0.157363902 10.9615341,0 11.3846168,0 L12,0 C12.4230774,0 12.7852555,0.157363902 13.0865376,0.472096098 C13.3878197,0.786832683 13.5384628,1.16517512 13.5384628,1.60714098 L13.5384628,2.57142732 L14.7692314,2.57142732 C15.1025669,2.57142732 15.3910226,2.69866098 15.6346152,2.9531239 C15.8782037,3.20759122 16,3.50892878 16,3.85714098 Z" id="icon/calendar"></path>\n            </g>\n        </g>\n    </g>\n    </svg>';
var $0b748888cf77b1cd$export$a80b3bd66acc52ff = '\n  <svg class="beratungshero--icon-info" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    <title>icon/info</title>\n    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">\n        <g id="BH-Popup-Variante-D" transform="translate(-193.000000, -375.000000)" fill-rule="nonzero">\n            <g id="Group" transform="translate(193.000000, 375.000000)">\n                <path d="M9,0 C13.9696364,0 18,4.03036364 18,9 C18,13.9696364 13.9696364,18 9,18 C4.02872728,18 0,13.9696364 0,9 C0,4.03036364 4.02872728,0 9,0 Z M9,1.8 C5.02345554,1.8 1.8,5.0238604 1.8,9 C1.8,12.9761396 5.02345554,16.2 9,16.2 C12.8943907,16.2 16.0680759,13.1057921 16.1959921,9.24243998 L16.2,9 C16.2,5.02447619 12.9755238,1.8 9,1.8 Z M9,7.2 C9.49705623,7.2 9.9,7.60294372 9.9,8.1 L9.9,8.1 L9.9,12.6 C9.9,13.0970562 9.49705623,13.5 9,13.5 C8.50294373,13.5 8.1,13.0970562 8.1,12.6 L8.1,12.6 L8.1,9 L7.82072753,9 C7.32367126,9 6.92072753,8.59705627 6.92072753,8.1 C6.92072753,7.60294372 7.32367126,7.2 7.82072753,7.2 L7.82072753,7.2 Z M9,4.5 C9.49705627,4.5 9.9,4.90294373 9.9,5.4 C9.9,5.89705627 9.49705627,6.3 9,6.3 C8.50294373,6.3 8.1,5.89705627 8.1,5.4 C8.1,4.90294373 8.50294373,4.5 9,4.5 Z" id="icon/info"></path>\n            </g>\n        </g>\n    </g>\n  </svg>';




function $9e6e34c3c7138ca1$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $20fa4ac5e52864a2$export$71511d61b312f219)(arr);
}


function $9bde86f51b71a757$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $00a17feca358b579$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $7fe6b322dfb9137b$export$71511d61b312f219(arr) {
    return (0, $9e6e34c3c7138ca1$export$71511d61b312f219)(arr) || (0, $9bde86f51b71a757$export$71511d61b312f219)(arr) || (0, $552f1931c107dd10$export$71511d61b312f219)(arr) || (0, $00a17feca358b579$export$71511d61b312f219)();
}




function $e62392e7a88672ed$export$99418391c9d4edd1(url, lang) {
    var regex = new RegExp("/".concat(lang, "$"));
    return url.match(regex);
}
function $e62392e7a88672ed$export$47b4274c3eda8f60(url) {
    return url.match(/\/(wishlist)/);
}
function $e62392e7a88672ed$export$fe63f8185eda093c(url) {
    return url.match(/\/(cart)/);
}
function $e62392e7a88672ed$export$22de9b359d32fa7a(url) {
    return url.match(/\/c\//);
}
function $e62392e7a88672ed$export$2fe592674bd7862e(url) {
    return url.match(/\/cp\//);
}
function $e62392e7a88672ed$export$a6ee0f0139d9689a(url) {
    return url.match(/\/p\//);
}
function $e62392e7a88672ed$export$3ee1ac535276712(url) {
    return url.match(/\/account\//);
}
function $e62392e7a88672ed$export$ab20bca5abfae9b7(url) {
    return url.match(/\/cp\/apple-mac-configurator/) || url.match(/\/cp\/produktfinder-cto/);
}
function $e62392e7a88672ed$export$92413a7c60d15e8a(url, category) {
    if ($e62392e7a88672ed$export$a6ee0f0139d9689a(url) && window.dataLayer) {
        var dataLayer = (0, $7fe6b322dfb9137b$export$71511d61b312f219)(window.dataLayer).reverse();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = dataLayer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.ecommerce && item.ecommerce.detail && item.ecommerce.detail.products && item.ecommerce.detail.products[0] && item.ecommerce.detail.products[0].category) {
                    var categoryUrl = item.ecommerce.detail.products[0].category;
                    return categoryUrl.match("/".concat(category));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return false;
}
function $e62392e7a88672ed$export$e8085726a03718aa(productArray) {
    try {
        if (!window.dataLayer) return null; // if no dataLayer array is found
        // Get a reversed copy of the dataLayer array
        var dataLayer = (0, $7fe6b322dfb9137b$export$71511d61b312f219)(window.dataLayer).reverse();
        // Find the element that contains the pgc attribute
        var foundElement = dataLayer.find(function(item) {
            return item.hasOwnProperty("pgc");
        });
        if (!foundElement) return null; // if no element with pgc attribute is found
        // Check if any value in the "pgc" array matches any element in the provided array
        var isMatch = foundElement.pgc.some(function(value) {
            return productArray.includes(value);
        });
        if (isMatch) return foundElement; // returns the matched element if a match is found
        else return null; // returns null if no match in the "pgc" array
    } catch (e) {
        console.error(e);
        return null;
    }
}
function $e62392e7a88672ed$export$8bcfff33a6c98fa4(url, categories) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            if ($e62392e7a88672ed$export$92413a7c60d15e8a(url, category)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}


function $1075a8f80138cc33$export$5c069c93d2b7493f(ms) {
    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            return resolve();
        }, ms);
    });
}
function $1075a8f80138cc33$export$d16800b7e59a8051(selector) {
    return $1075a8f80138cc33$var$_getElement.apply(this, arguments);
}
function $1075a8f80138cc33$var$_getElement() {
    $1075a8f80138cc33$var$_getElement = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(selector) {
        var tries, ms, el;
        var _arguments = arguments;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tries = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, ms = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 200;
                    if (tries > 20) return [
                        2,
                        null
                    ];
                    el = document.querySelector(selector);
                    if (el) return [
                        2,
                        el
                    ];
                    return [
                        4,
                        $1075a8f80138cc33$export$5c069c93d2b7493f(ms)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $1075a8f80138cc33$export$d16800b7e59a8051(selector, tries + 1, ms)
                    ];
            }
        });
    });
    return $1075a8f80138cc33$var$_getElement.apply(this, arguments);
}
function $1075a8f80138cc33$export$73eac51a39d6b0eb(selector) {
    return $1075a8f80138cc33$var$_getElements.apply(this, arguments);
}
function $1075a8f80138cc33$var$_getElements() {
    $1075a8f80138cc33$var$_getElements = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(selector) {
        var tries, ms, elements;
        var _arguments = arguments;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tries = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, ms = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 200;
                    if (tries > 10) return [
                        2,
                        null
                    ];
                    elements = document.querySelectorAll(selector);
                    if (elements && elements.length > 0) return [
                        2,
                        elements
                    ];
                    return [
                        4,
                        $1075a8f80138cc33$export$5c069c93d2b7493f(ms)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $1075a8f80138cc33$export$73eac51a39d6b0eb(selector, tries + 1, ms)
                    ];
            }
        });
    });
    return $1075a8f80138cc33$var$_getElements.apply(this, arguments);
}
function $1075a8f80138cc33$export$5009e7f3fa7b4cd3(eventName) {
    if (window.hj !== undefined) window.hj("event", eventName);
}
function $1075a8f80138cc33$export$4ddbf94935bfdfed(url) {
    for(var _len = arguments.length, parameter = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        parameter[_key - 1] = arguments[_key];
    }
    var urlParams = new URLSearchParams(url.split("?")[1] || "");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parameter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (urlParams.has(param[0])) {
                if (new URLSearchParams(param.join("=")).get(param[0]) === urlParams.get(param[0])) return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $1075a8f80138cc33$export$ff4971933d756b02(url) {
    for(var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        paths[_key - 1] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            if (path.test(url)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $1075a8f80138cc33$export$bfb231a5a6aca5de(theme) {
    var url = document.location.href.split("#")[0];
    if (theme === "micasa") {
        var parameterAndValuePairs = [
            [
                "q",
                "aktion"
            ],
            [
                "q",
                "action"
            ],
            [
                "q",
                "azione"
            ],
            [
                "q",
                "sale"
            ]
        ];
        if ($1075a8f80138cc33$export$4ddbf94935bfdfed.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(parameterAndValuePairs)))) return true;
        var urlRegex = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i,
            /.+\/de\/cp\/sale[\/|\?]?.*$/i,
            /.+\/fr\/cp\/sale[\/|\?]?.*$/i,
            /.+\/it\/cp\/sale[\/|\?]?.*$/i
        ];
        if ($1075a8f80138cc33$export$ff4971933d756b02.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(urlRegex)))) return true;
    } else if (theme === "sportxx" || theme === "sportx") {
        var parameterAndValuePairs1 = [
            [
                "q",
                "sale"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($1075a8f80138cc33$export$4ddbf94935bfdfed.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(parameterAndValuePairs1)))) return true;
        var urlRegex1 = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i
        ];
        if ($1075a8f80138cc33$export$ff4971933d756b02.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(urlRegex1)))) return true;
    } else if (theme === "melectronics") {
        var parameterAndValuePairs2 = [
            [
                "q",
                "salex"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($1075a8f80138cc33$export$4ddbf94935bfdfed.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(parameterAndValuePairs2)))) return true;
        var urlRegex2 = [
            /.+\/de\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/fr\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/it\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/de\/c\/\d+\/tv-audio\/fernseher[\/|\?]?.*$/i,
            /.+\/fr\/c\/\d+\/tv-audio\/televiseurs[\/|\?]?.*$/i,
            /.+\/it\/c\/\d+\/tv-audio\/televisori[\/|\?]?.*$/i,
            /.+\/de\/c\/\d+\/computing-tablets\/notebooks[\/|\?]?.*$/i,
            /.+\/fr\/c\/\d+\/computing-tablettes\/pc-portable[\/|\?]?.*$/i,
            /.+\/it\/c\/\d+\/computing-tablets\/pc-portatile[\/|\?]?.*$/i
        ];
        if ($1075a8f80138cc33$export$ff4971933d756b02.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(urlRegex2)))) return true;
        if ((0, $e62392e7a88672ed$export$e8085726a03718aa)([
            "Notebooks",
            "Fernseher"
        ])) return true;
    } else if (theme === "doitgarden") {
        var parameterAndValuePairs3 = [
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($1075a8f80138cc33$export$4ddbf94935bfdfed.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(parameterAndValuePairs3)))) return true;
        var urlRegex3 = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i,
            /.+\/de\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/fr\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/it\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/de\/outlet[\/|\?]?.*$/i,
            /.+\/fr\/outlet[\/|\?]?.*$/i,
            /.+\/it\/outlet[\/|\?]?.*$/i
        ];
        if ($1075a8f80138cc33$export$ff4971933d756b02.apply(void 0, [
            url
        ].concat((0, $7fe6b322dfb9137b$export$71511d61b312f219)(urlRegex3)))) return true;
    }
    return false;
}


function $34a2da8170297b5a$export$596743d694fcb1b6(_) {
    return $34a2da8170297b5a$var$_createBanner.apply(this, arguments);
}
function $34a2da8170297b5a$var$_createBanner() {
    $34a2da8170297b5a$var$_createBanner = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, _window_BH, _window, _window_BH1, _window1, texts, smartphone, div, reviews;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.bannerIsDisabled) return [
                        2
                    ];
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    smartphone = (0, $d547ae2449ccd11b$export$3c89af888305343f)(url);
                    div = ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_BH1 = _window1.BH) === null || _window_BH1 === void 0 ? void 0 : _window_BH1.newBanner) ? $34a2da8170297b5a$export$759cd82e04668984({
                        url: url,
                        consultant: consultant,
                        theme: theme,
                        lang: lang,
                        text: smartphone ? texts.mBudget.banner.title : texts.bannerTitle,
                        buttonText: "<span>".concat(smartphone ? texts.mBudget.banner.cta : texts.bannerButton, "</span>")
                    }) : $34a2da8170297b5a$export$477d3f7871bc78f7({
                        url: url,
                        consultant: consultant,
                        theme: theme,
                        lang: lang,
                        text: smartphone ? texts.mBudget.banner.title : texts.bannerTitle,
                        buttonText: "<span>".concat(smartphone ? texts.mBudget.banner.cta : texts.bannerButton, "</span>")
                    });
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)("#reviews")
                    ];
                case 1:
                    reviews = _state.sent();
                    if (reviews) {
                        reviews.parentNode.insertBefore(div, reviews);
                        $34a2da8170297b5a$export$8e6a1541577e86a7("BUTTON_BANNER_CLICKED");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $34a2da8170297b5a$var$_createBanner.apply(this, arguments);
}
function $34a2da8170297b5a$export$25c216e52ab8fda1(_) {
    return $34a2da8170297b5a$var$_createWishlistBanner.apply(this, arguments);
}
function $34a2da8170297b5a$var$_createWishlistBanner() {
    $34a2da8170297b5a$var$_createWishlistBanner = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, _window_BH, _window, texts, banner, wishlist, wishlistContainer;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.wishlistBannerDisabled) return [
                        2
                    ];
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    banner = $34a2da8170297b5a$var$createBannerDiv({
                        url: url,
                        consultant: consultant,
                        theme: theme,
                        lang: lang,
                        text: texts.wishlistTitle,
                        buttonText: "<span>".concat(texts.wishlistButton, "</span>")
                    });
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)(".wishlist.skel--root")
                    ];
                case 1:
                    wishlist = _state.sent();
                    if (wishlist) {
                        wishlistContainer = document.createElement("div");
                        banner.className = "wishlist--container";
                        wishlistContainer.appendChild(banner);
                        wishlist.appendChild(wishlistContainer);
                        $34a2da8170297b5a$export$8e6a1541577e86a7("BUTTON_WISHLIST_CLICKED");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $34a2da8170297b5a$var$_createWishlistBanner.apply(this, arguments);
}
function $34a2da8170297b5a$export$34b442c3d073f811(_) {
    return $34a2da8170297b5a$var$_createCartBanner.apply(this, arguments);
}
function $34a2da8170297b5a$var$_createCartBanner() {
    $34a2da8170297b5a$var$_createCartBanner = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, texts, banner, slider;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    banner = $34a2da8170297b5a$var$createBannerDiv({
                        url: url,
                        consultant: consultant,
                        theme: theme,
                        lang: lang,
                        text: texts.cartTitle,
                        buttonText: "<span>".concat(texts.cartButton, "</span>")
                    });
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)(".p-cart--row__last")
                    ];
                case 1:
                    slider = _state.sent();
                    if (slider) {
                        slider.parentNode.insertBefore(banner, slider);
                        $34a2da8170297b5a$export$8e6a1541577e86a7("BUTTON_CART_CLICKED");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $34a2da8170297b5a$var$_createCartBanner.apply(this, arguments);
}
function $34a2da8170297b5a$var$createBannerDiv(param) {
    var url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang, text = param.text, buttonText = param.buttonText;
    var _window_BH, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.bannerIsDisabled) return;
    var texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
    var avatarImage = consultant.imageAvatar;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_240/");
    else avatarImage = window.BH_URL + avatarImage;
    var div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = '\n  <div class="beratungshero--banner">\n    <div class="beratungshero--avatar-container">\n      <img src="'.concat(avatarImage, '" />\n      <div class="beratungshero--avatar-live">').concat(texts.widgetLive, '</div>\n    </div>\n    <div class="beratungshero--body">\n      <div class="beratungshero--left">\n        <div class="beratungshero--text">\n          <div class="beratungshero--title">\n            ').concat(text, '\n          </div>\n          <div class="beratungshero-list">\n            <div class="beratungshero--list-item">\n              ').concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(texts.widgetBodyBullet1, '\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="beratungshero--buttons beratungshero--buttons-center">\n        <a id="beratungshero-banner-video" class="beratungshero--more" href="').concat(window.BH_URL, "/").concat(theme, "/").concat(lang === "en" ? "de" : lang, "?connect=auto&url=").concat(encodeURIComponent(url), "&consultantId=").concat(consultant._id, '" target="_blank" rel="noopener noreferrer">\n      ').concat(buttonText, "\n    </a>\n      </div>\n    </div>\n  </div>\n  ");
    return div;
}
function $34a2da8170297b5a$export$477d3f7871bc78f7(param) {
    var url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang, text = param.text, buttonText = param.buttonText;
    var texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
    var avatarImage = consultant.imageAvatar;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_240/");
    else avatarImage = window.BH_URL + avatarImage;
    var urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(url));
    urlParams.append("consultantId", consultant._id);
    var finalLang = lang === "en" ? "de" : lang;
    var constructedUrl = "".concat(window.BH_URL, "/").concat(theme, "/").concat(finalLang, "?").concat(urlParams.toString());
    var div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = '\n  <div class="beratungshero--banner beratungshero--banner--pdp">\n    <div class="beratungshero--avatar-container">\n      <img src="'.concat(avatarImage, '" />\n      <div class="beratungshero--avatar-live">').concat(texts.widgetLive, '</div>\n    </div>\n    <div class="beratungshero--body beratungshero--body--pdp">\n      <div class="beratungshero--left">\n        <div class="beratungshero--text">\n          <div class="beratungshero--title">\n            ').concat(text, '\n          </div>\n          <div class="beratungshero-list">\n            <div class="beratungshero--list-item beratungshero--list-item--pdp">\n              ').concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(texts.widgetBodyBullet1, '\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="beratungshero--buttons beratungshero--buttons--pdp beratungshero--buttons-center">\n        <a id="beratungshero-banner-video" class="beratungshero--more" href="').concat(constructedUrl, '" target="_blank" rel="noopener noreferrer">\n      ').concat(buttonText, "\n    </a>\n      </div>\n    </div>\n  </div>\n  ");
    return div;
}
function $34a2da8170297b5a$export$759cd82e04668984(param) {
    var url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang, text = param.text, buttonText = param.buttonText;
    var texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
    var image = consultant.imageBranch;
    if (image.indexOf("https://") === 0) image = image.replace("upload/", "upload/w_540/");
    else image = window.BH_URL + image;
    var div = document.createElement("div");
    div.className = "beratungshero-banner-wrapper";
    div.innerHTML = '\n  <div class="beratungshero-banner-background"></div>\n  <div class="beratungshero-banner">\n    <div class="beratungshero-banner__img" style="background-image: url('.concat(image, ')"></div>\n    <div class="beratungshero-banner__content">\n      <div class="beratungshero-banner__title">\n        Hier und jetzt: unsere Beratung per Video\n      </div>\n      <div class="beratungshero-banner__list">\n        <div class="beratungshero-banner__list__item">\n          ').concat((0, $0b748888cf77b1cd$export$fe475e7e7b6e281b), ' Video-Beratung aus der Filiale\n        </div>\n        <div class="beratungshero-banner__list__item">\n          ').concat((0, $0b748888cf77b1cd$export$d658018a9147579e), ' Wunschprodukte zeigen lassen\n        </div>\n        <div class="beratungshero-banner__list__item">\n          ').concat((0, $0b748888cf77b1cd$export$9d7c7e61b1dce3b0), ' Ihr Bild wird nicht \xfcbertragen\n        </div>\n      </div>\n      <a id="beratungshero-banner-video" class="beratungshero-banner__button" href="').concat(window.BH_URL, "/").concat(theme, "/").concat(lang === "en" ? "de" : lang, "?connect=auto&url=").concat(encodeURIComponent(url), "&consultantId=").concat(consultant._id, '" target="_blank" rel="noopener noreferrer">\n      <div class="beratungshero-banner__button__live">\n        <div class="beratungshero-banner__button__live__green-bubble">\n        </div>\n        LIVE\n      </div>\n      Video-Beratung starten\n    </a>\n    </div>\n  </div>\n  ');
    return div;
}
function $34a2da8170297b5a$export$8e6a1541577e86a7(event) {
    var moreLink = document.querySelector("#beratungshero-banner-video");
    moreLink.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)(event);
    };
}






function $a2a40aec03e6bc02$export$752ff9cccbcd133d(_) {
    return $a2a40aec03e6bc02$var$_createSticker.apply(this, arguments);
}
function $a2a40aec03e6bc02$var$_createSticker() {
    $a2a40aec03e6bc02$var$_createSticker = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, _window_BH, _window, _window_BH1, _window1, texts, a, urlParams, finalLang, labelBoxes, labelBox;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.stickerIsDisabled) return [
                        2
                    ];
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    a = ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_BH1 = _window1.BH) === null || _window_BH1 === void 0 ? void 0 : _window_BH1.newSticker) ? $a2a40aec03e6bc02$var$createNewSticker(texts) : $a2a40aec03e6bc02$var$createOldSticker(texts, theme);
                    urlParams = new URLSearchParams();
                    urlParams.append("url", encodeURIComponent(url));
                    urlParams.append("consultantId", consultant._id);
                    urlParams.append("source", "sticker");
                    finalLang = lang === "en" ? "de" : lang;
                    a.href = "".concat(window.BH_URL, "/").concat(theme, "/").concat(finalLang, "?").concat(urlParams.toString());
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$73eac51a39d6b0eb)(".lNrTChs5SapUD1YBIbMU")
                    ];
                case 1:
                    labelBoxes = _state.sent();
                    if (labelBoxes) {
                        labelBox = labelBoxes.length > 1 ? labelBoxes[1] : labelBoxes[0];
                        $a2a40aec03e6bc02$var$insertSticker(labelBox, a);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $a2a40aec03e6bc02$var$_createSticker.apply(this, arguments);
}
function $a2a40aec03e6bc02$var$createNewSticker() {
    var a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker--new";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = '\n  <img class="beratungshero--sticker--new__consultant-image" src="https://res.cloudinary.com/db4fij86r/image/upload/v1631613733/consultants/MicrosoftTeams-image_21_n1mw8k.jpg" alt="consultant image" />\n  <img class="beratungshero--sticker--new__consultant-image beratungshero--sticker--new__consultant-image--right" src="https://res.cloudinary.com/db4fij86r/image/upload/v1613570250/consultants/zwnk5rtfbqyjnxqyb7tg.jpg" alt="consultant image" />\n  <span>Video-Beratung zum Produkt starten</span>\n  <div class="beratungshero--sticker--new__circle">\n    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="white"/>\n    </svg>\n  </div>\n  ';
    return a;
}
function $a2a40aec03e6bc02$var$createOldSticker(texts, theme) {
    var a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = "\n  <span>".concat(texts.stickerButton[theme] || texts.stickerButton.default, '</span>\n  <span class="beratungshero--sticker-live">').concat(texts.widgetLive, '</span>\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>\n  ');
    return a;
}
function $a2a40aec03e6bc02$var$insertSticker(labelBox, a) {
    labelBox.parentNode.insertBefore(a, labelBox);
    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("STICKER_SHOWN");
    var stickerLink = document.querySelector(".js__beratungshero--sticker");
    if (stickerLink) stickerLink.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_STICKER_CLICKED");
        (0, $1075a8f80138cc33$export$5009e7f3fa7b4cd3)("beratungshero_button_sticker_clicked");
    };
    $a2a40aec03e6bc02$var$logOptimizeEventStickerShown();
}
function $a2a40aec03e6bc02$var$logOptimizeEventStickerShown() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "optimize.macaron.shown"
    });
}


function $6c8329843422652c$var$getColors(theme) {
    switch(theme){
        case "bikeworld":
            return {
                primary: "#e6000a",
                primaryDark: "#b30008",
                avatarAnimation: "#1d1d1b",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#b30008",
                popupBorder: "1px solid #1d1d1b",
                popupButton: "#fff",
                popupButtonBg: "#e6000a",
                popupClose: "#fff",
                popupCloseBg: "#e6000a",
                stickerBg: "#1d1d1b",
                stickerBgHover: "#1d1d1b",
                widget: "#fff",
                widgetBg: "#1d1d1b",
                widgetBorder: "#1d1d1b",
                nivekiButtonBg: "#1d1d1b"
            };
        case "doitgarden":
            return {
                primary: "#063",
                primaryDark: "#00331a",
                avatarAnimation: "#063",
                popup: "#333",
                popupBg: "#eee",
                popupBgDark: "#00331a",
                popupBorder: "2px solid #063",
                popupButton: "#fff",
                popupButtonBg: "#063",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#00994d"
            };
        case "miocolor":
            return {
                primary: "#f60",
                primaryDark: "#00331a",
                avatarAnimation: "#f60",
                popup: "#333",
                popupBg: "#eee",
                popupBgDark: "#00331a",
                popupBorder: "2px solid #063",
                popupButton: "#fff",
                popupButtonBg: "#063",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#00994d",
                liveBg: "#063"
            };
        case "melectronics":
            return {
                primary: "#015ba7",
                primaryDark: "#163d82",
                avatarAnimation: "#015ba7",
                popup: "#fff",
                popupBg: "#015ba7",
                popupBgDark: "#163d82",
                popupBorder: "1px solid #015ba7",
                popupButton: "#fff",
                popupButtonBg: "#f60",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#0179da"
            };
        case "sportxx":
            return {
                primary: "#640015",
                primaryDark: "#500011",
                avatarAnimation: "#333333",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#1F1F1F",
                popupBorder: "1px solid #333333",
                popupButton: "#fff",
                popupButtonBg: "#640015",
                popupClose: "#fff",
                popupCloseBg: "#640015",
                stickerBg: "#333333",
                stickerBgHover: "#333333",
                widget: "#fff",
                widgetBg: "#333333",
                widgetBorder: "#333333",
                nivekiButtonBg: "#333333"
            };
        case "sportx":
            return {
                primary: "#630015",
                primaryDark: "#191919",
                avatarAnimation: "#f5a29d",
                popup: "#333333",
                popupBg: "#F4F4F4",
                popupBgDark: "#1F1F1F",
                popupBorder: "1px solid #F4F4F4",
                popupButton: "#fff",
                popupButtonBg: "#640015",
                popupClose: "#fff",
                popupCloseBg: "#640015",
                stickerBg: "#333333",
                stickerBgHover: "#333333",
                widget: "#fff",
                widgetBg: "#333333",
                widgetBorder: "#333333",
                nivekiButtonBg: "#333333" // Using sportx.secondaryLight
            };
        case "klubschule":
            return {
                primary: "#0053A6",
                primaryDark: "#00458d",
                avatarAnimation: "#0053A6",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#00458d",
                popupBorder: "1px solid #0053A6",
                popupButton: "#fff",
                popupButtonBg: "#0053A6",
                popupClose: "#fff",
                popupCloseBg: "#0053A6",
                stickerBg: "#1d1d1b",
                stickerBgHover: "#1d1d1b",
                widget: "#fff",
                widgetBg: "#0053A6",
                widgetBorder: "#0053A6"
            };
        default:
            // micasa
            return {
                primary: "#167f77",
                primaryDark: "#0e544e",
                avatarAnimation: "#167f77",
                popup: "#fff",
                popupBg: "#167f77",
                popupBgDark: "#0e544e",
                popupBorder: "1px solid #167f77",
                popupButton: "#fff",
                popupButtonBg: "#fcb23b",
                popupClose: "#167f77",
                popupCloseBg: "#fff",
                nivekiButtonBg: "#1ea99d"
            };
    }
}
function $6c8329843422652c$export$31f077b88a3c784c(theme, lang) {
    var _getColors = $6c8329843422652c$var$getColors(theme), avatarAnimation = _getColors.avatarAnimation, primary = _getColors.primary, primaryDark = _getColors.primaryDark, popup = _getColors.popup, popupBg = _getColors.popupBg, popupBorder = _getColors.popupBorder, popupBgDark = _getColors.popupBgDark, popupButton = _getColors.popupButton, popupButtonBg = _getColors.popupButtonBg, popupClose = _getColors.popupClose, popupCloseBg = _getColors.popupCloseBg, popupSolidBg = _getColors.popupSolidBg, stickerBg = _getColors.stickerBg, stickerBgHover = _getColors.stickerBgHover, widget = _getColors.widget, widgetBg = _getColors.widgetBg, widgetBorder = _getColors.widgetBorder, nivekiButtonBg = _getColors.nivekiButtonBg, liveBg = _getColors.liveBg, liveBgPopup = _getColors.liveBgPopup, _getColors_fontFamily = _getColors.fontFamily, fontFamily = _getColors_fontFamily === void 0 ? "inherit" : _getColors_fontFamily;
    var popupCss = "\n    .beratungshero--root {\n      box-sizing: border-box;\n      color: ".concat(popup, ";\n      font-family: ").concat(fontFamily, "\n    }\n\n    .beratungshero--root * {\n      box-sizing: border-box;\n    }\n\n    .beratungshero--button-reset {\n      border: none;\n      cursor: pointer;\n      margin: 0;\n      padding: 0;\n      width: auto;\n      overflow: visible;\n      background: transparent;\n      color: inherit;\n      font: inherit;\n      line-height: normal;\n      -webkit-font-smoothing: inherit;\n      -moz-osx-font-smoothing: inherit;\n      -webkit-appearance: none;\n    }\n\n    .beratungshero--button-reset:focus {\n      outline: none;\n    }\n\n    .beratungshero--close {\n      align-items: center;\n      background-color: ").concat(popupCloseBg, ";\n      border-radius: 50%;\n      border: 5px solid ").concat(popupSolidBg || popupBg, ";\n      color: ").concat(popupClose, ";\n      cursor: pointer;\n      display: flex;\n      height: 30px;\n      justify-content: center;\n      position: absolute;\n      margin-top: -5px;\n      margin-right: -5px;\n      top: 0;\n      right: 0;\n      width: 30px;\n    }\n\n    .beratungshero--close--mobile {\n      align-items: center;\n      background-color: ").concat(popupCloseBg, ";\n      border-radius: 50%;\n      margin: 5px;\n      color: ").concat(popupClose, ";\n      cursor: pointer;\n      display: flex;\n      height: 24px;\n      justify-content: center;\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 24px;\n      z-index: 1;\n    }\n\n    .beratungshero--close svg {\n      fill: currentColor;\n    }\n\n    .beratungshero--close--mobile svg {\n      fill: currentColor;\n    }\n\n    .beratungshero--skew {\n      // -moz-transform: skew(20deg, 0deg);\n      // -webkit-transform: skew(20deg, 0deg);\n      // -o-transform: skew(20deg, 0deg);\n      // -ms-transform: skew(20deg, 0deg);\n      // transform: skew(20deg, 0deg);\n      border-bottom: 110px solid red;\n      border-right: 25px solid transparent;\n      height: 0;\n    }\n\n    .beratungshero--avatar {\n      position: fixed;\n      bottom: 10px;\n      right: 10px;\n      z-index: 100;\n    }\n\n    .beratungshero--avatar.beratungshero--avatar--multiple1 {\n      right: 50px;\n    }\n\n    .beratungshero--avatar.beratungshero--avatar--multiple2 {\n      right: 21px;\n    }\n\n    .beratungshero--avatar.beratungshero--avatar--left {\n      left: 10px;\n      right: initial;\n    }\n\n    .beratungshero--avatar img {\n      border-radius: 50%;\n      border: 2px solid ").concat(widgetBorder || primary, ';\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n    }\n\n    .beratungshero--avatar video {\n      border-radius: 50%;\n      border: 2px solid #000;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n    }\n\n    .beratungshero--avatar-img {\n      position: relative;\n      height: 80px;\n      width: 80px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    .beratungshero--avatar-img:after {\n      content: "";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n      background-color: ').concat(avatarAnimation, ";\n      border-radius: 50%;\n      will-change: transform;\n    }\n\n    .beratungshero--avatar-img.beratungshero--avatar-pulse:after {\n      animation: beratungshero-pulse 2s infinite;\n    }\n\n    @keyframes beratungshero-pulse {\n      0% {\n        transform: scale(1);\n        opacity: 1;\n      }\n      100% {\n        transform: scale(1.2);\n        opacity: 0;\n      }\n    }\n\n    .beratungshero--avatar-img--sm {\n      height: 60px;\n      width: 60px;\n    }\n\n    .beratungshero--avatar-img--xs {\n      height: 40px;\n      width: 40px;\n    }\n\n    .beratungshero--avatar-img--multiple1-left {\n      position: absolute;\n      margin-left: -40px;\n      margin-top: auto;\n      margin-bottom: auto;\n      top: 0;\n      bottom: 0;\n      left: 0;\n    }\n\n    .beratungshero--avatar-img--multiple1-right {\n      position: absolute;\n      margin-right: -40px;\n      margin-top: auto;\n      margin-bottom: auto;\n      top: 0;\n      bottom: 0;\n      right: 0;\n    }\n\n    .beratungshero--avatar--multiple2 .beratungshero--avatar-img {\n      margin-left: -18px;\n    }\n\n    .beratungshero--avatar-img--multiple2-right {\n      position: absolute;\n      margin-right: -16px;\n      margin-top: 2px;\n      right: 0;\n    }\n\n    .beratungshero--avatar-img--multiple2-top-right {\n      position: absolute;\n      margin-right: -3px;\n      margin-top: -55px;\n      top: 0;\n      right: 0;\n    }\n\n    .beratungshero--avatar-title {\n      background-color: ").concat(widgetBg || primary, ";\n      border-radius: 4px;\n      color: ").concat(widget || "#fff", ";\n      font-size: 12px;\n      line-height: 1;\n      padding: 2px 4px;\n    }\n\n    .beratungshero--avatar-additional-title {\n      background-color: ").concat(widgetBg || primary, ";\n      border-radius: 4px;\n      color: ").concat(widget || "#fff", ";\n      font-size: 12px;\n      line-height: 1;\n      padding: 2px 4px;\n      width: 65px;\n      margin: 0 auto;\n    }\n\n    .beratungshero--popup {\n      background: ").concat(popupBg, ";\n      border: ").concat(popupBorder, ";\n      border-radius: 4px;\n      padding: 20px;\n      position: fixed;\n      bottom: 10px;\n      left: 10px;\n      right: 10px;\n      transition: all .5s ease-in-out;\n      transform: scale(0);\n      transform-origin: right bottom;\n      z-index: 101;\n    }\n\n    .beratungshero--popup--mobile {\n      padding: 0px;\n      border: none;\n      bottom: 5px;\n      left: 5px;\n      right: 5px;\n    }\n\n    .beratungshero--popup.beratungshero--popup--left {\n      transform-origin: left bottom;\n      left: 10px;\n    }\n\n    .beratungshero--popup--mobile.beratungshero--popup--left {\n      left: 5px;\n    }\n\n    .beratungshero--title {\n      margin: 0 15px 24px 15px;\n      text-align: center;\n      font-weight: 700;\n    }\n\n    .beratungshero--title--mobile {\n      margin-bottom: 9px;\n      text-align: left;\n      font-weight: 700;\n    }\n\n    .beratungshero--body {\n      position: relative;\n    }\n\n    .beratungshero--links-container {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .beratungshero--links-container--mobile {\n      display: flex;\n      justify-content: space-between;\n      padding: 10px;\n      background-color: ").concat(popupBgDark, ";\n      border: 1px solid ").concat(popupBgDark, ";\n      border-radius: 0 0 4px 4px;\n      font-size: 12px;\n    }\n\n    .beratungshero--link a {\n      display: flex;\n      align-items: center;\n      border-bottom: 0 !important;\n      color: ").concat(popup || "#fff", " !important;\n      text-decoration: underline !important;\n    }\n\n    .beratungshero--link--mobile span {\n      display: flex;\n      align-items: center;\n      color: #fff !important;\n    }\n\n    .beratungshero--link--mobile a {\n      display: flex;\n      align-items: center;\n      border-bottom: 0 !important;\n      color: #fff !important;\n      text-decoration: underline !important;\n    }\n\n    .beratungshero--avatar-container {\n      position: relative;\n      line-height: 0;\n    }\n\n    .beratungshero--avatar-live {\n      background-color: ").concat(liveBg || "#e84a42", ";\n      border-radius: 2px;\n      color: #fff;\n      font-size: 8px;\n      padding: 4px;\n      position: absolute;\n      bottom: 10px;\n      left: calc(50% + 20px);\n      line-height: 1;\n    }\n\n    .beratungshero--avatar .beratungshero--avatar-live {\n      bottom: 0;\n      right: 0;\n      left: auto;\n    }\n\n    .beratungshero--body img {\n      border-radius: 50%;\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      position: relative;\n      width: 100px;\n    }\n\n    .beratungshero-list {\n      margin-top: 20px;\n      display: flex;\n      justify-content: center;\n    }\n\n    .beratungshero--list-item {\n      align-items: center;\n      display: flex;\n      margin-bottom: 4px;\n    }\n\n    .beratungshero--list-item.beratungshero--list-item--pdp {\n      font-size: 13px;\n    }\n\n    .beratungshero--icon {\n      flex-shrink: 0;\n      fill: currentColor;\n      margin-right: 10px;\n      width: 20px;\n    }\n\n    .beratungshero--icon-calendar {\n      fill: currentColor;\n      margin-right: 5px;\n    }\n\n    .beratungshero--icon-info {\n      flex-shrink: 0;\n      fill: currentColor;\n      margin-right: 5px;\n      width: 20px;\n    }\n\n    .beratungshero-niveki-button-wrapper {\n      display: flex;\n      justify-content: center;\n    }\n\n    .beratungshero-niveki-button {\n      background-color: ").concat(nivekiButtonBg, ";\n      border-radius: 4px;\n      border: 0 !important;\n      color: ").concat(popupButton, " !important;\n      margin-bottom:16px;\n      overflow: hidden;\n      width: 100%;\n      padding: 10px;\n      text-align: left;\n      text-decoration: none;\n    }\n\n    .beratungshero-new-niveki-button {\n      border-radius: 4px;\n      border: 2px solid ").concat(popupButton, " !important;\n      color: ").concat(popupButton, " !important;\n      margin-bottom:16px;\n      overflow: hidden;\n      width: 100%;\n      padding: 10px;\n      text-align: left;\n      text-decoration: none;\n      display: flex;\n      font-weight: bold;\n      justify-content: center;\n      margin: 20px auto;\n    }\n\n    .beratungshero-content--mobile {\n      padding: 20px;\n      border: ").concat(popupBorder, ";\n      border-radius: 4px;\n    }\n\n    .beratungshero-niveki-button > span {\n      font-weight: bold;\n    }\n\n    .beratungshero-niveki-button > div {\n      font-size: 12px;\n    }\n\n    .beratungshero--more {\n      align-items: center;\n      background: ").concat(popupButtonBg, ";\n      border-radius: 4px;\n      border: 0 !important;\n      color: ").concat(popupButton, " !important;\n      display: flex;\n      font-weight: bold;\n      justify-content: center;\n      margin: 20px auto;\n      overflow: hidden;\n      padding: 10px;\n      text-align: center;\n      text-decoration: none !important;\n    }\n\n    .beratungshero--more--mobile {\n      align-items: center;\n      background-color: ").concat(popupButtonBg, ";\n      border-radius: 4px;\n      border: 0 !important;\n      color: ").concat(popupButton, " !important;\n      display: flex;\n      font-weight: bold;\n      justify-content: center;\n      margin: 0 auto;\n      overflow: hidden;\n      padding: 10px;\n      text-align: center;\n      text-decoration: none;\n    }\n\n    .beratungshero--chat {\n      align-items: center;\n      border: 0 !important;\n      color: #fff !important;\n      display: flex;\n      font-weight: bold;\n      justify-content: center;\n      margin-top: 10px;\n      margin-left: auto;\n      margin-right: auto;\n      overflow: hidden;\n      padding: 10px;\n      text-align: center;\n      text-decoration: none;\n    }\n\n    .beratungshero--hidden {\n      display: none !important;\n    }\n\n    .beratungshero--header {\n      background-size: cover;\n      background-position: top;\n      height: 200px;\n      margin-bottom: 20px;\n      position: relative;\n      border-radius: 4px;\n    }\n\n    .beratungshero--header-live {\n      position: absolute;\n      top: 10px;\n      left: 10px;\n      background-color: ").concat(liveBgPopup || "#e84a42", ";\n      color: #fff;\n      padding: 6px;\n      border-radius: 4px;\n      line-height: 1;\n    }\n\n    .beratungshero--show-video {\n      margin-right: 10px;\n    }\n\n    .beratungshero--popup--video {\n      width: 180px;\n      left: auto;\n      padding: 11px 11px 9px 11px;\n      font-size: 12px;\n    }\n\n    .beratungshero-popup__video {\n      position: relative;\n      margin-bottom: 9px;\n    }\n\n    .beratungshero-popup__video__live {\n      font-size: 11px;\n      top: 6px;\n      left: 6px;\n    }\n\n    .beratungshero-popup__video__close {\n      width: 36px;\n      height: 36px;\n      border-width: 6px;\n    }\n\n    .beratungshero-popup__video > video {\n      width: 100%;\n      height: auto;\n    }\n\n    .beratungshero-popup__video__button-no-sound {\n      position: absolute;\n      width: 76px;\n      height: 76px;\n      border-radius: 38px;\n      background: rgba(255, 255, 255, 0.33);\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      top: 50%;\n      margin-top: -34px;\n      left: 50%;\n      margin-left: -34px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .beratungshero-popup__video__button-wrapper {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      padding: 8px 8px 12px 8px;\n    }\n\n    .beratungshero-popup__video__button {\n      width: 100% !important;\n      padding: 6px;\n      margin: 0;\n      font-size: 12px;\n    }\n\n    @media screen and (min-width: 480px) {\n      .beratungshero--popup {\n        left: auto;\n        width: 440px;\n      }\n\n      .beratungshero--popup--video {\n        width: 214px;\n        font-size: inherit;\n        padding: 13px 13px 9px 13px;\n      }\n\n      .beratungshero-popup__video__button {\n        font-size: 14px;\n      }\n\n      .beratungshero--more, .beratungshero-new-niveki-button, .beratungshero--chat {\n        width: 75%;\n      }\n\n      .beratungshero-niveki-button {\n        width: 85%;\n      }\n    }\n\n    ").concat((theme === "sportxx" || theme === "sportx") && lang === "de" ? "" : ".back-to-top:not(.back-to-top__hidden) {\n          bottom: 120px;\n        }", "\n\n    @media screen and (min-width: 768px) {\n      .beratungshero--avatar {\n        bottom: 30px;\n        right: 30px;\n      }\n\n      .beratungshero--avatar.beratungshero--avatar--left {\n        left: 30px;\n      }\n\n      .beratungshero--avatar.beratungshero--avatar--multiple1 {\n        right: 70px;\n      }\n\n      .beratungshero--avatar.beratungshero--avatar--multiple2 {\n        right: 46px;\n      }\n\n      .beratungshero--popup {\n        bottom: 30px;\n        right: 30px;\n      }\n\n      .beratungshero--popup.beratungshero--popup--left {\n        left: 30px;\n      }\n\n      ").concat((theme === "sportxx" || theme === "sportx") && lang === "de" ? "" : ".back-to-top:not(.back-to-top__hidden) {\n          bottom: 140px;\n        }", "\n    }\n  ");
    var bannerCss = "\n  .beratungshero--root {\n    width: 100%;\n  }\n\n  .beratungshero--banner {\n    margin-top: 48px;\n    width: 100%;\n  }\n\n  .beratungshero--banner .beratungshero--title {\n    margin: 0 auto 0 auto;\n    text-align: left;\n  }\n\n  .beratungshero--banner .beratungshero--body {\n    background-color: #f2f2f2;\n    color: #333;\n    padding: 20px;\n  }\n\n  .beratungshero--banner .beratungshero--body.beratungshero--body--pdp {\n    background-color: transparent;\n  }\n\n  .beratungshero--left {\n    flex: 1;\n  }\n\n  .beratungshero--banner img {\n    height: 120px;\n    margin-left: 20px;\n  }\n\n  .beratungshero--banner .beratungshero--chat {\n    color: #333 !important;\n  }\n\n  .beratungshero--banner .beratungshero--avatar-live {\n    bottom: auto;\n    top: 0;\n    left: 140px;\n    font-size: 12px;\n  }\n\n  .beratungshero--banner .beratungshero--list-item svg {\n    fill: #555;\n  }\n\n  .beratungshero--banner .beratungshero-list {\n    justify-content: flex-start;\n  }\n\n  .beratungshero--banner .beratungshero--buttons {\n    display: flex;\n    margin-top: 20px;\n  }\n\n  .beratungshero--banner .beratungshero--buttons.beratungshero--buttons--pdp {\n    margin-top: 5px;\n  }\n\n  .beratungshero--banner .beratungshero--buttons.beratungshero--buttons--pdp .beratungshero--more {\n    padding: 10px 10px;\n  }\n\n  .beratungshero--banner .beratungshero--buttons-center {\n    align-items: center;\n  }\n\n  .beratungshero--banner .beratungshero--more {\n    flex-direction: column;\n    line-height: 1;\n    margin-top: 0;\n    padding: 10px 50px;\n  }\n\n  .beratungshero--banner .beratungshero--buttons-center .beratungshero--more {\n    width: 100%;\n  }\n\n  .beratungshero--banner .beratungshero--buttons .beratungshero--icon {\n    margin-bottom: 10px;\n    margin-right: 0;\n  }\n\n  .wishlist--container .beratungshero--banner {\n    margin-bottom: 48px;\n  }\n\n  .p-cart--container .beratungshero--banner {\n    margin-bottom: 48px;\n  }\n\n  @media screen and (min-width: 480px) {\n    .beratungshero--banner .beratungshero--more {\n      max-width: 360px;\n      width: auto;\n    }\n\n    .beratungshero--banner .beratungshero--buttons-center .beratungshero--more {\n      max-width: 100%;\n      width: 100%;\n    }\n\n    .beratungshero--banner .beratungshero--chat {\n      max-width: 360px;\n      width: auto;\n    }\n\n    .wishlist .beratungshero--banner .beratungshero--body {\n      display: flex;\n    }\n\n    .wishlist--container .beratungshero--banner .beratungshero--buttons-center {\n      padding-left: 10px;\n    }\n\n    .p-cart .beratungshero--banner .beratungshero--body {\n      display: flex;\n    }\n\n    .p-cart--container .beratungshero--banner .beratungshero--buttons-center {\n      padding-left: 10px;\n    }\n  }\n\n  @media screen and (min-width: 992px) {\n    .beratungshero--banner .beratungshero--body:not(.beratungshero--body--pdp) {\n      display: flex;\n    }\n\n    .beratungshero--banner.beratungshero--banner--pdp {\n      display: flex;\n    }\n\n    .beratungshero--body.beratungshero--body--pdp {\n      padding-top: 0px;\n      margin-left: 45px;\n    }\n\n    .beratungshero--banner .beratungshero--text {\n      padding-right: 20px;\n    }\n\n    .beratungshero--banner .beratungshero--buttons {\n      display: block;\n      margin-top: 0;\n    }\n\n    .beratungshero--banner .beratungshero--buttons.beratungshero--buttons-center {\n      display: flex;\n    }\n\n    .beratungshero--banner .beratungshero--more-chat {\n      margin-top: 20px;\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n  }\n\n  @media screen and (min-width: 1560px) {\n  }\n\n  .beratungshero-banner-wrapper {\n    position: relative;\n    padding-top: 27px;\n    margin-top: -28px;\n    margin-right: -20px;\n    margin-left: -20px;\n  }\n\n  .beratungshero-banner {\n    margin: 27px;\n    box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);\n    border-radius: 16px;\n    position: relative;\n    background-color: white;\n  }\n\n  .beratungshero-banner-background {\n    width: 100%;\n    background: ".concat(primary, ";\n    position: absolute;\n    height: 65%;\n    border-radius: 16px;\n  }\n\n  .beratungshero-banner__img {\n    width: 100%;\n    height: 188px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .beratungshero-banner__content {\n    padding: 10px 24px 24px 24px;\n  }\n\n  .beratungshero-banner__title {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .beratungshero-banner__list {\n    margin: 16px 0px 27px 5px;\n  }\n\n  .beratungshero-banner__list__item {\n    align-items: center;\n    display: flex;\n    margin-bottom: 12px;\n    font-size: 14px;\n  }\n\n  .beratungshero-banner__list__item > svg {\n    color: ").concat(primary, "\n  }\n\n  .beratungshero-banner__button {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 13px;\n    background: ").concat(primary, ";\n    border-radius: 8px;\n    width: 100%;\n    color: white !important;\n  }\n\n  .beratungshero-banner__button__live {\n    display: flex;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.4);\n    padding: 4px 10px 4px 6px;\n    font-size: 12px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n    margin-right: 10px;\n  }\n\n  .beratungshero-banner__button__live__green-bubble {\n    width: 8px;\n    height: 8px;\n    background-color: #1FAF7C;\n    border-radius: 4px;\n    margin-right: 4px;\n  }\n\n  @media screen and (min-width: 992px) {\n    .beratungshero-banner-wrapper {\n      margin: 0;\n    }\n\n    .beratungshero-banner {\n      display: flex;\n      margin: 27px 0px 27px 27px;\n    }\n\n    .beratungshero-banner__img {\n      width: 50%;\n      height: auto;\n      border-radius: 16px 0px 0px 16px;\n    }\n\n    .beratungshero-banner-background {\n      width: 55%;\n      height: 100%;\n    }\n  }\n\n  ");
    var stickerCss = "\n    .beratungshero--sticker {\n      background-color: ".concat(stickerBg || primary, ";\n      color: white !important;\n      position: absolute;\n      right: 0;\n      padding: 8px 16px;\n      cursor: pointer;\n      border-radius: 4px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      top: 0;\n      font-size: 90%;\n      line-height: 1;\n      z-index: 1;\n      border-bottom: 0px !important;\n    }\n\n    @media screen and (max-width: 990px) {\n      .beratungshero--sticker {\n        top: 45px;\n      }\n    }\n\n    .beratungshero--sticker:hover {\n      background-color: ").concat(stickerBgHover || primaryDark, ";\n    }\n\n    .beratungshero--sticker svg {\n      fill: currentColor;\n      height: 10px;\n      margin-left: 8px;\n      width: 10px;\n    }\n\n    .beratungshero--sticker-live {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: ").concat(liveBg || "#e84a42", ";\n      padding: 4px;\n      border-radius: 4px;\n      margin-top: -16px;\n      margin-right: 8px;\n    }\n\n    .beratungshero--sticker--new {\n      background-color: ").concat(stickerBg || primary, ";\n      color: white !important;\n      position: absolute;\n      right: 0;\n      padding: 4px 6px;\n      cursor: pointer;\n      border-radius: 35px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      top: -5px;\n      line-height: 1;\n      z-index: 1;\n      border-bottom: 0px !important;\n    }\n\n    .beratungshero--sticker--new > span {\n      margin-left: 44px;\n      max-width: 165px;\n      line-height: 20px;\n    }\n\n    .beratungshero--sticker--new__consultant-image {\n      border: 2px solid white;\n      border-radius: 22px;\n      height: 44px;\n      width: 44px;\n      flex-shrink: 0;\n    }\n\n    .beratungshero--sticker--new__consultant-image--right {\n      position: absolute;\n      left: 36px;\n      z-index: -1;\n    }\n\n    .beratungshero--sticker--new__circle {\n      background-color: ").concat(primaryDark, ";\n      color: white;\n      border-radius: 22px;\n      height: 44px;\n      width: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-left: 12px;\n      flex-shrink: 0;\n    }\n\n\n    @media screen and (max-width: 990px) {\n      .beratungshero--sticker--new {\n        top: 29px;\n      }\n    }\n\n    @media screen and (max-width: 425px) {\n      .beratungshero--sticker--new {\n        width: 100%;\n      }\n      .beratungshero--sticker--new > span {\n        max-width: none;\n      }\n    }\n\n\n    .beratungshero--mobile-configurator {\n      border: 2px solid transparent;\n      border-width: 2px !important;\n      border-color: ").concat(primary, ";\n      color: ").concat(primary, ";\n      cursor: pointer;\n      border-radius: 4px;\n      text-decoration: none;\n      line-height: 1;\n      font-size: 1.4rem;\n      padding: 6px 8px;\n      width: 100%;\n      font-weight: 700;\n      font-style: normal;\n      display: inline-flex;\n      flex-flow: column nowrap;\n      align-items: center;\n    }\n\n    .beratungshero--miocolor-product-finder {\n      border: 2px solid transparent;\n      border-width: 2px !important;\n      border-color: ").concat(primary, ";\n      color: ").concat(primary, ";\n      cursor: pointer;\n      border-radius: 4px;\n      text-decoration: none;\n      font-size: 1.4rem;\n      font-weight: 700;\n      font-style: normal;\n      display: inline-flex;\n      flex-flow: column nowrap;\n      align-items: center;\n      float: right;\n      padding: 0 1em;\n      height: 32px;\n      line-height: 28px;\n      margin-bottom: 10px;\n    }\n\n    @media screen and (max-width: 991px) {\n      .beratungshero--miocolor-product-finder {\n        margin-right: 8px;\n      }\n    }\n\n    .beratungshero--miocolor-product-finder > span  {\n      padding: 0 4px;\n      font-family: \"Helvetica Neue Condensed Bold\",Helvetica,Arial,sans-serif;\n      font-weight: 400;\n    }\n\n    .cursor-pointer {\n      cursor: pointer;\n    }\n\n    .beratungshero-video-wrapper{\n        overflow: hidden\n    }\n\n    .beratungshero-video-wrapper video{\n        margin-left: -3px\n    }\n\n    .lazy {\n      background-image: none !important;\n    }\n\n    .beratungshero-button {\n      padding: 8px 8px;\n      cursor: pointer;\n      border-radius: 4px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 90%;\n      line-height: 1;\n      z-index: 1;\n    }\n\n    .beratungshero-button > span {\n      text-align: center;\n      font-weight: bold;\n    }\n\n    .beratungshero__livestream-fake__widget > video {\n      height: 100%;\n      width: 100%;\n      border-radius: 9px;\n      position: absolute;\n    }\n\n    .beratungshero__livestream-fake__live {\n      z-index: 1;\n      position: absolute;\n      top: 7px;\n      left: 7px;\n      padding: 7px 8px;\n      font-size: var(--live-label-font-size, 12px);\n      color: var(--live-label-text-color, #ffffff);\n      background-color: var(--live-label-bg-color, #E12147);\n      border-radius: var(--border-radius, 0);\n      font-weight: var(--live-label-font-weight, 'normal');\n    }\n\n    .beratungshero__livestream-fake__fader {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      background-color: #000;\n      opacity: 0;\n      top: 0;\n      left: 0;\n      transition: opacity .2s;\n      border-radius: 8px;\n      cursor: pointer;\n    }\n\n    .beratungshero__livestream-fake--active > .beratungshero__livestream-fake__fader {\n        opacity: .65;\n    }\n\n    .beratungshero__livestream-fake__cta {\n      opacity: 0;\n      z-index: 1;\n      transition: opacity .2s;\n      border: 1px solid #fff;\n      text-align: center;\n      padding: 8px;\n      margin-left: 16px;\n      margin-right: 16px;\n      font-size: 12px;\n      color: white;\n    }\n\n    .beratungshero__livestream-fake__cta-container {\n      display: flex;\n      align-items: center;\n      height: 100%;\n    }\n\n    .beratungshero__livestream-fake__close {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 44px;\n      height: 44px;\n      z-index: 1;\n      transition: opacity .2s;\n    }\n\n    .beratungshero__livestream-fake--active .beratungshero__livestream-fake__cta {\n        opacity: 1;\n    }\n\n    .beratungshero__livestream-fake__live-circle {\n      position: fixed;\n      bottom: 16px;\n      right: 16px;\n      width: 56px;\n      height: 56px;\n      text-transform: var(--live-label-text-transform, 'uppercase');\n      color: var(--live-label-text-color, #ffffff);\n      background-color: var(--live-label-bg-color, #E12147);\n      font-weight: var(--live-label-font-weight, 'normal');\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      cursor: pointer;\n      font-size: 12px;\n      font-family: Haas Grot, Helvetica, Arial, Verdana, Tahoma, sans-serif;\n    }\n\n    .beratungshero__livestream-fake__overlay {\n      position: fixed;\n      bottom: 0;\n      right: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.55);\n      overscroll-behavior: none;\n      z-index: 2147483647;\n      cursor: pointer;\n    }\n\n    .beratungshero__livestream-fake__overlay__content {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%,-50%);\n      width: 100%;\n      max-width: 500px;\n    }\n\n    .beratungshero__livestream-fake__overlay__live {\n      border-radius: 4px;\n      font-size: 12px;\n      text-transform: uppercase;\n      font-weight: 500;\n      background-color: #2a2a2a;\n      font-family: \"NeueHaasGrotText\",sans-serif;\n      padding: 8px;\n      background-color: #e12147;\n      color: #fff;\n      position: absolute;\n      top: 7px;\n      left: 7px;\n    }\n\n    .beratungshero__livestream-fake__overlay__close {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 48px;\n      height: 48px;\n      z-index: 1;\n      transition: opacity .2s;\n      cursor: pointer;\n    }\n\n    .beratungshero__livestream-fake__overlay__spinner {\n      border: 5px solid #f3f3f3;\n      -webkit-animation: spin 1s linear infinite;\n      animation: spin 1s linear infinite;\n      border-top: 5px solid #555;\n      border-radius: 50%;\n      width: 50px;\n      height: 50px;\n      margin-right: auto;\n      margin-left: auto;\n    }\n\n    @keyframes spin {\n      0% { transform: rotate(0deg); }\n      100% { transform: rotate(360deg); }\n    }\n  ");
    var switchCss = ".switch{display:inline-block;vertical-align:middle;cursor:pointer;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;box-sizing:content-box;outline:none}.switch,.switch small{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.switch small{font-size:12px;top:0;border-radius:100%;text-align:center;display:block;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.4);-webkit-transition:all .2s;transition:all .2s;overflow:hidden;color:#000}.switch-default{width:50px;height:30px;border-radius:20px;line-height:30px}.switch-default small{width:30px;height:30px}.switch-small{border-radius:20px;height:20px;width:33px;line-height:20px}.switch-small small{height:20px;width:20px}.switch-large{border-radius:40px;height:40px;width:66px;line-height:40px}.switch-large small{height:40px;width:40px}.switch-disabled{opacity:.5}";
    var css = popupCss + bannerCss + stickerCss + switchCss;
    var style = document.createElement("style");
    style.type = "text/css";
    style.id = "bh-widget-style";
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}
function $6c8329843422652c$export$eb1d1800c11907c2() {
    console.log("removeStyles");
    var style = document.getElementById("bh-widget-style");
    console.log(style);
    if (style) style.remove();
}




var $0552d01fece86a1f$export$f7c6a91a611d8278 = {
    bikeworld: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1632476949/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0001_tqk0ke.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1632476697/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0002-min_wnvnjb.jpg"
    ],
    doitgarden: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1619439397/consultants/fm_live_videoberatung_doit_wankdorf_nicole_grau_4_21_P3A2309_tjymld.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1619439451/consultants/fm_live_videoberatung_doit_wankdorf_nicole_grau_4_21_P3A2418_ipgvdr.jpg"
    ],
    melectronics: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571632/consultants/eahunbbkeofnactmc3nl.jpg",
        "/static/images/fachmarkt/popup_melectronics_termin.jpg"
    ],
    micasa: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613570541/consultants/bo8f5ixderizksjdeohd.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613570547/consultants/k0quu9fia4vbnaiy4spk.jpg"
    ],
    sportxx: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571096/consultants/ch6bazosn8fkpgscfm7g.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571102/consultants/idf3elwcez8syrzw7hns.jpg"
    ],
    sportx: [
        "https://res.cloudinary.com/db4fij86r/image/upload/w_500/v1693299009/consultants/beratungsheros_sportxx_8_23_Micha_Burkolter_P3A8623-1_1_cpjjec.png",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1693311499/image_4_cftkdf.png"
    ],
    klubschule: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1609830211/consultants/cn2nct1sesbzi9krv5gj.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1609830226/consultants/agil4a2ks1uyxi1ntyqo.jpg"
    ]
};
var $0552d01fece86a1f$export$af5fbebaeacc3fa3 = {
    de: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_fonczd.png",
    fr: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_FR_bhqoi0.png",
    it: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_IT_sdlwpm.png"
};



function $f2df12b8418717de$export$d856f5947026c431(param) {
    var consultant = param.consultant, theme = param.theme, lang = param.lang, variant = param.variant, _param_hidden = param.hidden, hidden = _param_hidden === void 0 ? false : _param_hidden, booking = param.booking, bookingLink = param.bookingLink, landingPageUrl = param.landingPageUrl, tenant = param.tenant, position = param.position, _param_widgetType = param.widgetType, widgetType = _param_widgetType === void 0 ? "default" : _param_widgetType, _param_popupVideoUrl = param.popupVideoUrl, popupVideoUrl = _param_popupVideoUrl === void 0 ? null : _param_popupVideoUrl, from = param.from, url = param.url;
    var _window_BH, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.widgetIsDisabled) return;
    var texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
    var smartphonePage = (0, $d547ae2449ccd11b$export$3c89af888305343f)(url);
    var avatarImage = booking ? (0, $0552d01fece86a1f$export$f7c6a91a611d8278)[theme][0] : consultant ? consultant.imageAvatar : null;
    var branchImage = smartphonePage ? (0, $0552d01fece86a1f$export$af5fbebaeacc3fa3)[lang] : booking ? (0, $0552d01fece86a1f$export$f7c6a91a611d8278)[theme][1] : consultant ? consultant.imageBranch : null;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_160/");
    else avatarImage = window.BH_URL + avatarImage;
    if (branchImage.indexOf("https://") === 0) branchImage = branchImage.replace("upload/", "upload/w_800/");
    else branchImage = window.BH_URL + branchImage;
    // For bikeworld to sportxx fallback during winter
    if (from === "bikeworld") {
        avatarImage = "https://res.cloudinary.com/db4fij86r/image/upload/v1632476949/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0001_tqk0ke.jpg";
        branchImage = "https://res.cloudinary.com/db4fij86r/image/upload/v1632476697/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0002-min_wnvnjb.jpg";
        landingPageUrl = "https://www.bikeworld.ch/de/cp/videoberatung";
    }
    /*function redirectToCall() {
    let shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) {
      shopUrl = "https://qual-www.micasa.ch/de/p/405750100000/diener";
    }
    let videoCallUrl = booking
      ? bookingLink
      : `${
          window.BH_URL
        }/${theme}/${lang}?connect=auto&url=${encodeURIComponent(
          shopUrl
        )}&consultantId=${consultant._id}`;

    window.open(videoCallUrl, "_blank", "noopener noreferrer");
  }*/ var popupPrimaryButtonUrl = getPopupPrimaryButtonUrl(booking, bookingLink, theme, lang, $f2df12b8418717de$var$getShopUrl(), consultant);
    var div = document.createElement("div");
    div.className = "beratungshero--root";
    if (hidden) div.style.display = "none";
    var nivekiEnabled = tenant.nivekiEnabled && !!window.BH.nivekiEnabled;
    if (popupVideoUrl !== null && !booking) div.innerHTML = '\n    <div class="beratungshero--popup beratungshero--popup--video '.concat(position === "left" ? "beratungshero--popup--left" : "", '">\n      <div id="beratungshero-popup-content">\n      <div class="beratungshero-popup__video">\n        <video class="js-beratungshero-popup-video"\n          src="').concat(window.BH_URL + popupVideoUrl, '"\n          autoplay="true" playsinline="true" webkit-playsinline="true" muted loop>\n        </video>\n        <div class="beratungshero--close beratungshero-popup__video__close">').concat((0, $0b748888cf77b1cd$export$8360e631d277ea4d), '</div>\n        <div class="beratungshero--header-live beratungshero-popup__video__live">LIVE</div>\n        <div class="beratungshero-popup__video__button-no-sound js-beratungshero-popup-no-sound">').concat((0, $0b748888cf77b1cd$export$c3694a0927aa4b45), '</div>\n        <div class="beratungshero-popup__video__button-wrapper">\n          <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more beratungshero-popup__video__button cursor-pointer" href="').concat(getPopupPrimaryButtonUrl(), '" target="_blank" rel="noreferrer noopener">\n            Video-Beratung starten\n          </a>\n        </div>\n        </div>\n\n        <!--<div class="beratungshero--header lazy" style="background-image: url(\'').concat(branchImage, '\');">\n          <div class="beratungshero--close">').concat((0, $0b748888cf77b1cd$export$8360e631d277ea4d), '</div>\n          <div class="beratungshero--header-live">LIVE</div>\n        </div>-->\n\n        <div class="beratungshero--links-container" ').concat(theme === "klubschule" ? 'style="display: none;"' : "", '>\n          <div class="beratungshero--link">\n          </div>\n          <div id="beratungshero-link-how-it-works" class="beratungshero--link">\n            <a href=').concat(landingPageUrl, ' target="_blank" rel="noopener">').concat((0, $0b748888cf77b1cd$export$a80b3bd66acc52ff)).concat(texts.widgetInfoLink, "</a>\n          </div>\n        </div>\n      </div>\n    </div>");
    else if (variant === 1 || booking) // Large PopUp
    div.innerHTML = '\n    <div class="beratungshero--popup '.concat(booking ? "beratungshero--booking" : "", " ").concat(position === "left" ? "beratungshero--popup--left" : "", '">\n      <div id="beratungshero-popup-content">\n        <div class="beratungshero--header lazy" style="background-image: url(\'').concat(branchImage, '\');">\n          <div class="beratungshero--close">').concat((0, $0b748888cf77b1cd$export$8360e631d277ea4d), "</div>\n          ").concat(booking ? "" : '<div class="beratungshero--header-live">LIVE</div>', '\n        </div>\n        <div class="beratungshero--title" ').concat(nivekiEnabled ? 'style="margin-bottom: 0px"' : "", ">\n          ").concat(smartphonePage ? texts.mBudget.widget.title : booking ? texts.widgetTitleBooking : nivekiEnabled ? texts.nivekiTitle : texts.widgetTitle[theme] || texts.widgetTitle.default, "\n        </div>\n        ").concat(!nivekiEnabled && theme !== "miocolor" ? getNotSeenPart() : "", "\n        ").concat(theme === "miocolor" ? getMiocolorPart() : "", '\n        <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more cursor-pointer" href="').concat(getPopupPrimaryButtonUrl(), '" target="_blank" rel="noreferrer noopener" style="').concat(nivekiEnabled ? "margin-top: 10px; margin-bottom: 10px" : "", '">\n          ').concat(booking ? (0, $0b748888cf77b1cd$export$56bbcdb8aca31149) : "", "\n          ").concat(booking ? texts.widgetButtonBooking : nivekiEnabled ? texts.nivekiPrimaryButton : smartphonePage ? texts.mBudget.widget.cta : texts.widgetButton[theme] || texts.widgetButton.default, "\n        </a>\n        ").concat(nivekiEnabled ? getNotSeenPart() : "", "\n        ").concat(nivekiEnabled ? getNivekiButton() : "", '\n        <div class="beratungshero--links-container" ').concat(theme === "klubschule" ? 'style="display: none;"' : "", '>\n          <div class="beratungshero--link">\n          </div>\n          <div id="beratungshero-link-how-it-works" class="beratungshero--link">\n            <a href=').concat(landingPageUrl, ' target="_blank" rel="noopener">').concat((0, $0b748888cf77b1cd$export$a80b3bd66acc52ff)).concat(nivekiEnabled ? texts.nivekiWidgetInfoLink : texts.widgetInfoLink, "</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  ");
    else div.innerHTML = '\n    <div class="beratungshero--popup beratungshero--popup--mobile '.concat(booking ? "beratungshero--booking" : "", " ").concat(position === "left" ? "beratungshero--popup--left" : "", '">\n      <div id="beratungshero-popup-content">\n        <div class="beratungshero--close--mobile">').concat((0, $0b748888cf77b1cd$export$8360e631d277ea4d), '</div>\n        <div style="display: flex; position:relative">\n          <div style="width: 66.66%">\n            <div style="padding: 12px 14px 12px 16px">\n              <div class="beratungshero--title--mobile">\n                ').concat(smartphonePage ? texts.mBudget.widget.title : texts.widgetTitle[theme] || texts.widgetTitle.default, '\n              </div>\n              <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more--mobile cursor-pointer" href="').concat(getPopupPrimaryButtonUrl(), '" target="_blank" rel="noreferrer noopener">\n                ').concat(smartphonePage ? texts.mBudget.widget.cta : texts.widgetButton[theme] || texts.widgetButton.default, '\n              </a>\n            </div>\n          </div>\n          <div style="width: 33.33%; background-image: url(').concat(branchImage, '); -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%); border-radius: 0 4px 0 0; background-size: cover;\n        background-position: center;"></div>\n        </div>\n        <div class="beratungshero--links-container--mobile" ').concat(theme === "klubschule" ? 'style="display: none;"' : "", '>\n          <div class="beratungshero--link--mobile">\n              <span>').concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(smartphonePage ? texts.mBudget.widget.subtitle : texts.widgetBodyBullet1, '</span>\n          </div>\n          <div id="beratungshero-link-how-it-works" class="beratungshero--link--mobile">\n            <a href=').concat(landingPageUrl, ' target="_blank" rel="noopener">').concat((0, $0b748888cf77b1cd$export$a80b3bd66acc52ff)).concat(texts.widgetInfoLink, "</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  ");
    div.innerHTML += getWidget();
    document.body.appendChild(div);
    var avatar = document.querySelector(".beratungshero--avatar");
    avatar.onclick = togglePopup;
    var closeButton = document.querySelector(".beratungshero--close");
    if (!closeButton) closeButton = document.querySelector(".beratungshero--close--mobile");
    closeButton.onclick = function() {
        togglePopup();
        if (popupVideoUrl !== null) {
            var video = document.querySelector(".js-beratungshero-popup-video");
            video.muted = true;
            var activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
            setTimeout(function() {
                activateSoundButton.style.display = "flex";
            }, 1000);
        }
    };
    var videoCallButton = document.querySelector("#beratungshero-popup-video");
    videoCallButton.onclick = function(e) {
        if (booking) (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_APPOINTMENT_CLICKED");
        else {
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_CLICKED", {
                url: document.location.href
            });
            (0, $1075a8f80138cc33$export$5009e7f3fa7b4cd3)("beratungshero_button_clicked");
        }
    /*if (!booking && tenant.nivekiEnabled && !isMobile()) {
      e.preventDefault(); // Don't redirect to call
      logEvent("POPUP_NIVEKI");
      showNiveki();
    }*/ };
    var howItWorksLink = document.querySelector("#beratungshero-link-how-it-works");
    howItWorksLink.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("LINK_HOW_IT_WORKS_CLICKED");
    };
    var nivekiButton = document.querySelector("#beratungshero-niveki-button");
    if (nivekiButton) nivekiButton.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_POPUP_NIVEKI_CLICKED");
    };
    var activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
    if (activateSoundButton) activateSoundButton.onclick = activateSoundButtonClicked;
    function togglePopup() {
        var popup = document.querySelector(".beratungshero--popup");
        if (window.BH.widgetClosed) {
            if (popupVideoUrl !== null) $f2df12b8418717de$export$ae6c4758b5042ef8();
            $f2df12b8418717de$export$cfae72848eff8ed2();
            popup.style.transform = "scale(1)";
            avatar.querySelector(".beratungshero--avatar-img").classList.remove("beratungshero--avatar-pulse");
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("WIDGET_OPENED");
        } else {
            popup.style.transform = "scale(0)";
            avatar.querySelector(".beratungshero--avatar-img").classList.add("beratungshero--avatar-pulse");
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("WIDGET_CLOSED");
        }
        window.BH.widgetClosed = !window.BH.widgetClosed;
    }
    function showNiveki() {
        var popupContent = document.querySelector("#beratungshero-popup-content");
        popupContent.innerHTML = getNivekiContent();
        var nivekiButton1 = document.querySelector("#beratungshero-niveki-button-1");
        nivekiButton1.onclick = function() {
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_1_CLICKED");
            $f2df12b8418717de$var$openInNewTab(texts.nivekiButton1Link[theme]);
        };
        var nivekiButton2 = document.querySelector("#beratungshero-niveki-button-2");
        nivekiButton2.onclick = function() {
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_2_CLICKED");
            $f2df12b8418717de$var$openInNewTab(texts.nivekiButton2Link[theme]);
        };
        var nivekiButton3 = document.querySelector("#beratungshero-niveki-button-3");
        nivekiButton3.onclick = function() {
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_3_CLICKED");
            $f2df12b8418717de$var$openInNewTab(texts.nivekiButton3Link[theme]);
        };
        var nivekiButtonVideo = document.querySelector("#beratungshero-niveki-button-video");
        nivekiButtonVideo.onclick = function() {
            (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_CALL_CLICKED");
        };
        var closeButton = document.querySelector(".beratungshero--close");
        if (!closeButton) closeButton = document.querySelector(".beratungshero--close--mobile");
        closeButton.onclick = togglePopup;
    }
    function getWidget() {
        var multipleConsultantAvatars;
        if (theme === "melectronics") multipleConsultantAvatars = [
            "https://res.cloudinary.com/db4fij86r/image/upload/v1629181421/consultants/fotos_onlineberater_melectronics_sch%C3%B6nb%C3%BChl_002-min_kn9l3z.jpg",
            "https://res.cloudinary.com/db4fij86r/image/upload/v1629181466/consultants/fotos_onlineberater_melectronics_sch%C3%B6nb%C3%BChl_001-min_ajtuay.jpg"
        ];
        else if (theme === "micasa") multipleConsultantAvatars = [
            "https://res.cloudinary.com/db4fij86r/image/upload/v1612423871/consultants/a8utsbdbio1ki7sikfqg.jpg",
            "https://res.cloudinary.com/db4fij86r/image/upload/v1613570250/consultants/zwnk5rtfbqyjnxqyb7tg.jpg"
        ];
        return '<button class="beratungshero--button-reset beratungshero--avatar beratungshero--avatar--'.concat(widgetType, " ").concat(position === "left" ? "beratungshero--avatar--left" : "", '">\n      <div class="beratungshero--avatar-container">\n        ').concat(widgetType === "multiple1" ? '<div class="beratungshero--avatar-img beratungshero--avatar-img--sm beratungshero--avatar-img--multiple1-left beratungshero--avatar-pulse">\n          <img src="'.concat(multipleConsultantAvatars[0], '"  alt="consultant"/>\n        </div>\n        <div class="beratungshero--avatar-img beratungshero--avatar-img--sm beratungshero--avatar-img--multiple1-right beratungshero--avatar-pulse">\n          <img src="').concat(multipleConsultantAvatars[1], '"  alt="consultant"/>\n        </div>') : "", "\n        ").concat(widgetType === "multiple2" ? '<div class="beratungshero--avatar-img--sm beratungshero--avatar-img--multiple2-top-right">\n          <img src="'.concat(multipleConsultantAvatars[0], '"  alt="consultant"/>\n        </div>\n        <div class="beratungshero--avatar-img--xs beratungshero--avatar-img--multiple2-right">\n          <img src="').concat(multipleConsultantAvatars[1], '"  alt="consultant"/>\n        </div>') : "", '\n        <div class="beratungshero--avatar-img beratungshero--avatar-pulse">\n          <img src="').concat(avatarImage, '"  alt="consultant"/>\n        </div>\n        ').concat(booking ? "" : '<div class="beratungshero--avatar-live">'.concat(texts.widgetLive, "</div>"), '\n      </div>\n      <div class="beratungshero--avatar-title">').concat(booking ? texts.widgetAvatarTitleBooking : texts.widgetAvatarTitle[theme] || texts.widgetAvatarTitle.default, "</div>\n      ").concat(!booking && $f2df12b8418717de$var$isSunday() ? '<div class="beratungshero--avatar-additional-title">'.concat(texts.widgetSundayToo, "</div>") : "", "\n      ").concat(!booking && !$f2df12b8418717de$var$isSunday() && $f2df12b8418717de$var$getFromOperatingHour(tenant) && $f2df12b8418717de$var$getToOperatingHour(tenant) ? '<div class="beratungshero--avatar-additional-title">'.concat(texts.widgetHours.replace("__FROM__", $f2df12b8418717de$var$getFromOperatingHour(tenant)).replace("__TO__", $f2df12b8418717de$var$getToOperatingHour(tenant)), "</div>") : "", "\n    </button>");
    }
    function getNivekiContent() {
        return "\n    <div ".concat(variant === 2 ? 'class="beratungshero-content--mobile"' : "", '>\n      <div style="position: relative; height: 40px;">\n        <div class="beratungshero--close">').concat((0, $0b748888cf77b1cd$export$8360e631d277ea4d), '</div>\n      </div>\n      <div class="beratungshero--title">\n        ').concat(texts.nivekiTitle, '\n      </div>\n      <div class="beratungshero-niveki-button-wrapper">\n        <button id="beratungshero-niveki-button-1" class="beratungshero-niveki-button cursor-pointer">\n          <span>').concat(texts.nivekiButton1, "</span>\n          <div>").concat(texts.nivekiButton1Subtext, '</div>\n        </button>\n      </div>\n      <div class="beratungshero-niveki-button-wrapper">\n        <button id="beratungshero-niveki-button-2" class="beratungshero-niveki-button cursor-pointer">\n          <span>').concat(texts.nivekiButton2, "</span>\n          <div>").concat(texts.nivekiButton2Subtext, '</div>\n        </button>\n      </div>\n      <div class="beratungshero-niveki-button-wrapper">\n        <button id="beratungshero-niveki-button-3" class="beratungshero-niveki-button cursor-pointer">\n          <span>').concat(texts.nivekiButton3, "</span>\n          <div>").concat(texts.nivekiButton3Subtext, '</div>\n        </button>\n      </div>\n      <a id="beratungshero-niveki-button-video" class="js-beratungshero-popup-primary-button beratungshero--more cursor-pointer" href="').concat(getPopupPrimaryButtonUrl(), '" target="_blank" rel="noreferrer noopener">\n        ').concat(texts.nivekiPrimaryButton, "\n      </a>\n    </div>");
    }
    function getPopupPrimaryButtonUrl() {
        var urlParams = new URLSearchParams();
        if (booking) return "".concat(bookingLink, "?").concat(urlParams.toString());
        else {
            urlParams.append("connect", "auto");
            urlParams.append("url", encodeURIComponent($f2df12b8418717de$var$getShopUrl()));
            urlParams.append("consultantId", consultant._id);
            if (from) urlParams.append("from", from);
            return "".concat(window.BH_URL, "/").concat(theme, "/").concat(lang, "?").concat(urlParams.toString());
        }
    }
    function getNotSeenPart() {
        return '<div class="beratungshero--body">\n    <div class="beratungshero-list" '.concat(nivekiEnabled ? 'style="margin-top: 0px"' : "", '>\n      <div class="beratungshero--list-item">\n        ').concat(smartphonePage ? texts.mBudget.widget.subtitle : booking ? texts.widgetBodyBooking[theme] || texts.widgetBodyBooking.default : "".concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(smartphonePage ? texts.mBudget.widget.subtitle : texts.widgetBodyBullet1), "\n      </div>\n    </div>\n  </div>");
    }
    function activateSoundButtonClicked() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_ACTIVATE_SOUND_CLICKED");
        var video = document.querySelector(".js-beratungshero-popup-video");
        video.muted = false;
        var activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
        activateSoundButton.style.display = "none";
    }
    function getMiocolorPart() {
        return '\n      <div style="text-align: center">\n        Unser spezialisierter Farbexperte ber\xe4t Sie live per Video-Beratung \xfcber unser Farbangebot.\n      </div>';
    }
    function getNivekiButton() {
        return '<a id="beratungshero-niveki-button" class="beratungshero-new-niveki-button cursor-pointer" href="'.concat(texts.nivekiButtonLink[theme], '" target="_blank" rel="noreferrer noopener">\n        ').concat(texts.nivekiButton, "\n    </a>");
    }
    $f2df12b8418717de$var$logOptimizeEventWidgetShown18to20(booking);
    $f2df12b8418717de$var$logOptimizeEventWidgetShown(booking);
}
function $f2df12b8418717de$var$openInNewTab(url) {
    window.open(url, "_blank", "noopener noreferrer");
}
function $f2df12b8418717de$var$logOptimizeEventWidgetShown18to20(booking) {
    if (booking) return;
    var date = new Date();
    // Do not log on friday (it's until 21.30)
    if (date.getDay() === 5) return;
    var hour = date.getHours();
    // Do not log before 18:00 or after 20:00
    if (hour < 18 || hour > 20) return;
    window.datalayer = window.datalayer || [];
    window.dataLayer.push({
        event: "optimize.widget.shown.18.to.20"
    });
}
function $f2df12b8418717de$var$logOptimizeEventWidgetShown(booking) {
    if (booking) return;
    window.datalayer = window.datalayer || [];
    window.dataLayer.push({
        event: "optimize.widget.shown"
    });
}
function $f2df12b8418717de$var$isMobile() {
    var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return vw <= 640;
}
function $f2df12b8418717de$var$isSunday() {
    var today = new Date();
    return today.getDay() === 0;
}
function $f2df12b8418717de$var$getFromOperatingHour(tenant) {
    var today = new Date();
    if (tenant.operatingHours[today.getDay()] && tenant.operatingHours[today.getDay()].length === 1 && tenant.operatingHours[today.getDay()][0].from) return $f2df12b8418717de$var$getDisplayTime(tenant.operatingHours[today.getDay()][0].from);
    return null;
}
function $f2df12b8418717de$var$getToOperatingHour(tenant) {
    var today = new Date();
    if (tenant.operatingHours[today.getDay()] && tenant.operatingHours[today.getDay()].length === 1 && tenant.operatingHours[today.getDay()][0].to) return $f2df12b8418717de$var$getDisplayTime(tenant.operatingHours[today.getDay()][0].to);
    return null;
}
function $f2df12b8418717de$var$getDisplayTime(time) {
    var splitTime = time.split(":");
    var timeString = $f2df12b8418717de$var$removeLeadingZeros(splitTime[0]);
    if (splitTime.length > 1) {
        if ($f2df12b8418717de$var$removeLeadingZeros(splitTime[1]) > 0) timeString += ":".concat(splitTime[1]);
    }
    return timeString;
}
function $f2df12b8418717de$var$removeLeadingZeros(numString) {
    return parseInt(numString, 10);
}
function $f2df12b8418717de$var$getShopUrl() {
    var shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) shopUrl = "https://qual-www.micasa.ch/de/p/405750100000/diener";
    return shopUrl;
}
function $f2df12b8418717de$export$cfae72848eff8ed2() {
    var image = document.querySelector(".lazy");
    if (image) image.classList.remove("lazy");
}
function $f2df12b8418717de$export$ae6c4758b5042ef8() {
    var video = document.querySelector(".js-beratungshero-popup-video");
    if (video) video.currentTime = 0;
}


var $82d7d99f625a9d8d$exports = {};
$82d7d99f625a9d8d$exports = JSON.parse('{"bannerTitle":"<b>Haben Sie weitere Fragen?</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","bannerButton":"Video-Beratung starten","cartButton":"Jetzt verbinden","cartTitle":"<b>Haben Sie Fragen zu Ihrer Bestellung?</b><br /><b>Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent unterst\xfctzen.</b>","configuratorStartPageTitle":"Hilfe beim Konfigurieren","configuratorStartPageSubtitle":"Nutzen Sie zum Konfigurieren unsere Video-Beratung - bequem von zu hause aus.","configuratorStartPageButton":"Videoberatung starten","configuratorStartPageText":"Brauchen Sie Hilfe bei der Konfiguration? Nutzen Sie unsere Video-Beratung: live, kostenlos und unverbindlich.","configuratorStartPageTextOffline":"Brauchen Sie Hilfe bei der Konfiguration? Nutzen Sie unsere Video-Beratung: kostenlos und unverbindlich.","configuratorStartPageLink":"Jetzt Video-Beratung starten","configuratorStartPageLinkOffline":"Jetzt Termin vereinbaren","configuratorConsultant":"Beratung","configuratorButton":"Hilfe? Unsere Video-Beratung unterst\xfctzt Sie","mobileConfiguratorButton":"Zum M\xf6belkonfigurator per Video-Beratung","nivekiTitle":"Wie k\xf6nnen wir Ihnen helfen?","nivekiButton":"Zum Online-Hilfecenter","nivekiButtonLink":{"doitgarden":"https://help.doitgarden.ch/hc/de","melectronics":"https://help.melectronics.ch/hc/de","micasa":"https://help.micasa.ch/hc/de","sportxx":"https://help.sportx.ch/hc/de"},"nivekiButton1":"Ich habe Fragen zu meiner Bestellung","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/contactFormPage","melectronics":"https://www.melectronics.ch/de/cp/contactFormPage","micasa":"https://www.micasa.ch/de/cp/contactFormPage","sportxx":"https://www.sportx.ch/de/cp/contactFormPage"},"nivekiButton1Subtext":"Probleme mit Rechnung, Lieferung, Reparatur...","nivekiButton2":"Ich habe Fragen zum Onlineshop","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/de/categories/360002637600-Vor-meiner-Bestellung","melectronics":"https://help.melectronics.ch/hc/de/categories/360002647099-Vor-meiner-Bestellung","micasa":"https://help.micasa.ch/hc/de/categories/360002637760-Vor-meiner-Bestellung","sportxx":"https://help.sportx.ch/hc/de/categories/360002647659-Vor-meiner-Bestellung"},"nivekiButton2Subtext":"Probleme mit Gutscheinen, Zahlung...","nivekiButton3":"Ich habe Fragen zu meiner Filiale","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/storefinder","melectronics":"https://www.melectronics.ch/de/cp/storefinder","micasa":"https://www.micasa.ch/de/cp/storefinder","sportxx":"https://www.sportx.ch/de/cp/storefinder"},"nivekiButton3Subtext":"Alles \xfcber \xd6ffnungszeiten, Filialbest\xe4nde...","nivekiPrimaryButton":"Video-Beratung starten","nivekiWidgetInfoLink":"So funktioniert die Video-Beratung","stickerButton":{"miocolor":"Video-Beratung vom Farbexperten","default":"Video-Beratung zum Produkt"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Rahmengr\xf6sse via Video-Beratung ermitteln"}},"widgetAvatarTitle":{"miocolor":"Video-Beratung Farbexperte","default":"Video-Beratung"},"widgetAvatarTitleBooking":"Video-Beratung<br />buchen","widgetTitle":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","miocolor":"Live Video-Beratung von unseren Farbexperten","default":"Von Zuhause aus das gleiche Einkaufserlebnis wie in der Filiale!"},"widgetTitleBooking":"Kostenlose Live Video-Beratung vereinbaren.","widgetBodyBullet1":"Ihr Bild wird nicht \xfcbertragen","widgetBodyBooking":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Von Zuhause aus, das gleiche Einkaufserlebnis wie im Laden!"},"widgetButton":{"default":"Jetzt Video-Beratung starten"},"widgetButtonBooking":"Termin vereinbaren","widgetHours":"__FROM__ - __TO__ Uhr","widgetInfoLink":"So funktioniert es","widgetLive":"LIVE","wishlistButton":"Produkte zeigen lassen","widgetSundayToo":"Auch Sonntags!","wishlistTitle":"<b>K\xf6nnen wir Sie bei Ihrer Wahl unterst\xfctzen?</b><br />Alle Produkte k\xf6nnen wir Ihnen bei einem Videogespr\xe4ch live zeigen.","mBudget":{"widget":{"title":"Mit Handy-Abo bis zu 150.- Rabatt f\xfcrs neue Smartphone!","subtitle":"Lassen Sie sich per Video beraten. Ihr Bild wird nicht \xfcbertragen","cta":"Jetzt Video-Beratung starten und profitieren"},"banner":{"title":"<b>Mit Handy-Abo bis zu 150.- Rabatt f\xfcrs neue Smartphone!</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","cta":"Jetzt Video-Beratung starten und profitieren"}}}');


var $81267ec388b1673b$exports = {};
$81267ec388b1673b$exports = JSON.parse('{"bannerTitle":"<b>Haben Sie weitere Fragen?</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","bannerButton":"Video-Beratung starten","cartButton":"Jetzt verbinden","cartTitle":"<b>Haben Sie Fragen zu Ihrer Bestellung?</b><br /><b>Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent unterst\xfctzen.</b>","configuratorStartPageTitle":"Hilfe beim Konfigurieren","configuratorStartPageSubtitle":"Nutzen Sie zum Konfigurieren unsere Video-Beratung - bequem von zu hause aus.","configuratorStartPageButton":"Videoberatung starten","configuratorStartPageText":"Do you need help with the configuration? Use our video consultation: live, free of charge and without obligation.","configuratorStartPageTextOffline":"Do you need help with the configuration? Use our video consultation: live, free of charge and without obligation.","configuratorStartPageLink":"Start video consultation","configuratorStartPageLinkOffline":"Book an appointment","configuratorConsultant":"Consulting","configuratorButton":"Hilfe? Unsere Video-Beratung unterst\xfctzt Sie","mobileConfiguratorButton":"Zum M\xf6belkonfigurator per Video-Beratung","nivekiTitle":"How can we help?","nivekiButton":"Online Helpcenter","nivekiButtonLink":{"doitgarden":"https://help.doitgarden.ch/hc/de","melectronics":"https://help.melectronics.ch/hc/de","micasa":"https://help.micasa.ch/hc/de","sportxx":"https://help.sportx.ch/hc/de"},"nivekiButton1":"I have questions about my order","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/contactFormPage","melectronics":"https://www.melectronics.ch/de/cp/contactFormPage","micasa":"https://www.micasa.ch/de/cp/contactFormPage","sportxx":"https://www.sportx.ch/de/cp/contactFormPage"},"nivekiButton1Subtext":"Problems with invoices, deliveries, repairs, etc.","nivekiButton2":"I have questions about the online shop","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/de/categories/360002637600-Vor-meiner-Bestellung","melectronics":"https://help.melectronics.ch/hc/de/categories/360002647099-Vor-meiner-Bestellung","micasa":"https://help.micasa.ch/hc/de/categories/360002637760-Vor-meiner-Bestellung","sportxx":"https://help.sportx.ch/hc/de/categories/360002647659-Vor-meiner-Bestellung"},"nivekiButton2Subtext":"Problems with vouchers, payment, etc.","nivekiButton3":"I have questions about my local store","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/storefinder","melectronics":"https://www.melectronics.ch/de/cp/storefinder","micasa":"https://www.micasa.ch/de/cp/storefinder","sportxx":"https://www.sportx.ch/de/cp/storefinder"},"nivekiButton3Subtext":"All you need to know about opening hours, stock, etc.","nivekiPrimaryButton":"Videoberatung starten","nivekiWidgetInfoLink":"So funktioniert die Videoberatung","stickerButton":{"default":"Video-Beratung zum Produkt"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Rahmengr\xf6sse via Video-Beratung ermitteln"}},"widgetAvatarTitle":{"default":"Video advice<br />in English or German"},"widgetAvatarTitleBooking":"Book<br />video advice","widgetTitle":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Video advice in English or German: Connected to our store"},"widgetTitleBooking":"Schedule free live video advice.","widgetBodyBullet1":"You will not be visible.","widgetBodyBooking":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Get the same shopping experience at home as at a store!"},"widgetButton":{"default":"Start video advice"},"widgetButtonBooking":"Schedule appointment","widgetHours":"__FROM__-__TO__","widgetInfoLink":"Here\'s how","widgetLive":"LIVE","wishlistButton":"Produkte zeigen lassen","widgetSundayToo":"Even on Sunday!","wishlistTitle":"<b>Can we assist you in choosing in either English or German?</b><br />We can show you any product during a live video chat."}');


var $b3a234f48cdbaf79$exports = {};
$b3a234f48cdbaf79$exports = JSON.parse('{"bannerTitle":"<b>Vous avez d\'autres questions?</b><br />Nous pouvons vous renseigner directement lors d\'un appel vid\xe9o.","bannerButton":"D\xe9marrer le conseil vid\xe9o","cartButton":"Se connecter","cartTitle":"<b>Avez-vous des questions relatives \xe0 votre commande?</b><br /><b>Nous pouvons vous offrir un conseil comp\xe9tent lors d\u2019un entretien vid\xe9o.</b>","configuratorStartPageTitle":"Aide \xe0 la configuration","configuratorStartPageSubtitle":"Utilisez notre conseil vid\xe9o pour configurer vos meubles, confortablement depuis chez vous.","configuratorStartPageButton":"Lancer le conseil vid\xe9o","configuratorStartPageText":"Besoin d\u2019aide pour la configuration? Profitez de nos conseils vid\xe9o: en direct, gratuitement et sans engagement.","configuratorStartPageTextOffline":"Besoin d\u2019aide pour la configuration? Profitez de nos conseils vid\xe9o: en direct, gratuitement et sans engagement.","configuratorStartPageLink":"D\xe9marrez le conseil vid\xe9o","configuratorStartPageLinkOffline":"Je prends rendez-vous","configuratorConsultant":"Conseil","configuratorButton":"Besoin d\u2019aide? Notre conseil vid\xe9o est \xe0 votre service.","mobileConfiguratorButton":"Conseil vid\xe9o pour configurer ses meubles","nivekiTitle":"En quoi pouvons-nous vous \xeatre utiles?","nivekiButton1":"J\u2019ai des questions sur ma commande","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/fr/cp/contactFormPage","melectronics":"https://www.melectronics.ch/fr/cp/contactFormPage","micasa":"https://www.micasa.ch/fr/cp/contactFormPage","sportxx":"https://www.sportx.ch/fr/cp/contactFormPage"},"nivekiButton1Subtext":"Des probl\xe8mes avec la facture, la livraison...","nivekiButton2":"J\u2019ai des questions sur la boutique en ligne","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/fr/categories/360002637600-Avant-ma-commande","melectronics":"https://help.melectronics.ch/hc/fr/categories/360002647099-Avant-ma-commande","micasa":"https://help.micasa.ch/hc/fr/categories/360002637760-Avant-ma-commande","sportxx":"https://help.sportx.ch/hc/fr/categories/360002647659-Avant-ma-commande"},"nivekiButton2Subtext":"Probl\xe8mes avec des bons, le paiement, r\xe9paration...","nivekiButton3":"J\u2019ai des questions sur mon magasin","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/fr/cp/storefinder","melectronics":"https://www.melectronics.ch/fr/cp/storefinder","micasa":"https://www.micasa.ch/fr/cp/storefinder","sportxx":"https://www.sportx.ch/fr/cp/storefinder"},"nivekiButton3Subtext":"Tout sur les heures d\u2019ouverture, les stocks en magasin...","nivekiPrimaryButton":"Continuer vers les conseils produits","stickerButton":{"default":"Conseil vid\xe9o sur le produit"},"themeSpecific":{"bikeworld":{"sizeTableButton":"D\xe9termination de la taille du cadre par consultation vid\xe9o"}},"widgetAvatarTitle":{"default":"Conseil vid\xe9o"},"widgetAvatarTitleBooking":"R\xe9server un conseil<br />vid\xe9o","widgetTitle":{"klubschule":"Des incertitudes ? Pas de probl\xe8me, nous sommes l\xe0 pour vous.","default":"De chez vous, la m\xeame exp\xe9rience d\'achat qu\'en magasin!"},"widgetTitleBooking":"Planifiez gratuitement un appel vid\xe9o avec un conseiller.","widgetBodyBullet1":"Votre cam\xe9ra ne sera pas active","widgetBodyBooking":{"klubschule":"Des incertitudes ? Pas de probl\xe8me, nous sommes l\xe0 pour vous.","default":"Un contact direct avec votre magasin, sans bouger de chez vous !"},"widgetButton":{"default":"Lancer le conseil vid\xe9o"},"widgetButtonBooking":"Planifier un appel vid\xe9o","widgetHours":"__FROM__ h \xe0 __TO__ h","widgetInfoLink":"Comment \xe7a marche ?","widgetLive":"LIVE","wishlistButton":"Voir les produits en direct","widgetSundayToo":"Aussi Dimanche !","wishlistTitle":"<b>Pouvons-nous vous aider dans votre choix?</b><br />Nous pouvons vous montrer tous les produits en direct lors d\'un appel vid\xe9o.","mBudget":{"widget":{"title":"Avec l\u2019abonnement mobile, jusqu\u2019\xe0 150.- de r\xe9duction pour votre nouveau smartphone!","subtitle":"Faites-vous conseiller par vid\xe9o. Votre cam\xe9ra ne sera pas active","cta":"Lancer le conseil vid\xe9o et en profiter"},"banner":{"title":"<b>Avec l\u2019abonnement mobile, jusqu\u2019\xe0 150.- de r\xe9duction pour votre nouveau smartphone!</b><br />Nous vous conseillons avec comp\xe9tence lors d\u2019un entretien vid\xe9o.","cta":"Lancer le conseil vid\xe9o et en profiter"}}}');


var $63036b4732656168$exports = {};
$63036b4732656168$exports = JSON.parse('{"bannerTitle":"<b>Ha altre domande?</b><br />Le possiamo offrire una consulenza competente tramite una conversazione video.","bannerButton":"Comincia la videoconsulenza","cartButton":"Collegare adesso","cartTitle":"<b>Hai domande sulla tua ordinazione?</b><br /><b>Possiamo offrirti una consulenza professionale con una videochiamata.</b>","configuratorStartPageTitle":"Aiuto nella configurazione","configuratorStartPageSubtitle":"Per la configurazione utilizza la nostra videoconsulenza, comodamente da casa tua.","configuratorStartPageButton":"Avvia la videoconsulenza","configuratorStartPageText":"Hai bisogno di aiuto con la configurazione? Utilizza la nostra videoconsulenza: live, gratuita e senza impegno. \u200B","configuratorStartPageTextOffline":"Hai bisogno di aiuto con la configurazione? Utilizza la nostra videoconsulenza: live, gratuita e senza impegno. \u200B","configuratorStartPageLink":"Inizia subito la videoconsulenza","configuratorStartPageLinkOffline":"Fissa ora un appuntamento","configuratorConsultant":"Consulenza","configuratorButton":"Hai bisogno di aiuto? La nostra videoconsulenza \xe8 qui per te","mobileConfiguratorButton":"Al configuratore di mobili tramite videoconsulenza","nivekiTitle":"Come possiamo aiutarti?","nivekiButton1":"Ho domande sulla mia ordinazione","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/it/cp/contactFormPage","melectronics":"https://www.melectronics.ch/it/cp/contactFormPage","micasa":"https://www.micasa.ch/it/cp/contactFormPage","sportxx":"https://www.sportx.ch/it/cp/contactFormPage"},"nivekiButton1Subtext":"Problemi con fattura, consegna, riparazione...","nivekiButton2":"Ho domande sullo shop online","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/it/categories/360002637600-Prima-del-mio-ordine","melectronics":"https://help.melectronics.ch/hc/it/categories/360002647099-Prima-del-mio-ordine","micasa":"https://help.micasa.ch/hc/it/categories/360002637760-Prima-del-mio-ordine","sportxx":"https://help.sportx.ch/hc/it/categories/360002647659-Prima-del-mio-ordine"},"nivekiButton2Subtext":"Problemi con buoni, pagamento...","nivekiButton3":"Ho domande sulla mia filiale","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/it/cp/storefinder","melectronics":"https://www.melectronics.ch/it/cp/storefinder","micasa":"https://www.micasa.ch/it/cp/storefinder","sportxx":"https://www.sportx.ch/it/cp/storefinder"},"nivekiButton3Subtext":"Tutto su orari di apertura, stock filiale...","nivekiPrimaryButton":"Avanti a consulenza prodotti","stickerButton":{"default":"Videoconsulenza sul prodotto"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Determinare la dimensione del telaio tramite consultazione video"}},"widgetAvatarTitle":{"default":"Videoconsulenza"},"widgetAvatarTitleBooking":"Prenota la<br />Videoconsulenza","widgetTitle":{"klubschule":"Incertezze? Nessun problema, siamo qui per voi.","default":"Da casa la stessa esperienza d\u2019acquisto come in negozio!"},"widgetTitleBooking":"Pianificare una consulenza video in diretta gratuita.","widgetBodyBullet1":"La sua immagine non verr\xe0 trasmessa","widgetBodyBooking":{"klubschule":"Incertezze? Nessun problema, siamo qui per voi.","default":"Shopping da casa con la stessa esperienza di acquisto in negozio!"},"widgetButton":{"default":"Comincia la Videoconsulenza"},"widgetButtonBooking":"Fissare un appuntamento","widgetHours":"__FROM__ alle __TO__","widgetInfoLink":"Funziona cosi","widgetLive":"LIVE","wishlistButton":"Mostrare i prodotti","widgetSundayToo":"Anche la domenica!","wishlistTitle":"<b>Desidera la nostra assistenza nella scelta del prodotto?</b><br /> Tutti i prodotti possono essere mostrati LIVE tramite una conversazione video.","mBudget":{"widget":{"title":"Con l\'abbonamento per cellulare fino a 150.- di riduzione sul nuovo smartphone!","subtitle":"Fatti consigliare tramite video. La sua immagine non verr\xe0 trasmessa","cta":"Avvia una videoconsulenza e approfittane"},"banner":{"title":"<b>Con l\'abbonamento per cellulare fino a 150.- di riduzione sul nuovo smartphone!</b><br />Possiamo offrirti una consulenza professionale con una videochiamata.","cta":"Avvia una videoconsulenza e approfittane"}}}');


function $68bc11eae8fdf90e$export$b33daf2836bb52dc() {
    /*return "eyJzdHJhdGVneU1lc3NhZ2UiOiJLdW5kZW4sIGRpZSBkaWVzZW4gQXJ0aWtlbCBrYXVmdGVuLCBrYXVmdGVuIGF1Y2giLCJyZWNvbW1lbmRlZFByb2R1Y3RJZHMiOlsiNDAyOTQwNTAwMDAwIiwiNDIwMzc3MDAwMDAwIiwiNDIwNzY1MTAwMDAwIiwiNDMwOTE4NTAwMDgwIiwiNDUwNjI4ODQwNTEwIiwiNDAyMzU5NDAwMDEwIiwiNDUxNjI4NzQzMTIwIiwiNDUwOTA3MTA0MDgwIl19";
   */ var richrelevance = window.RR_DEBUG;
    if (richrelevance && richrelevance.response && richrelevance.response.placements && richrelevance.response.placements[1]) {
        var recommendedProducts = richrelevance.response.placements[1].recommendedProducts;
        var strategyMessage = richrelevance.response.placements[1].strategyMessage;
        var recommendedProductIds = recommendedProducts.map(function(recommendedProduct) {
            return recommendedProduct.id;
        });
        var feed = {
            strategyMessage: strategyMessage,
            recommendedProductIds: recommendedProductIds
        };
        return btoa(JSON.stringify(feed));
    }
}






var $7a7492651f58eb1f$var$MOBILE_CONFIGURATOR_CLASS = "beratungshero--mobile-configurator";
function $7a7492651f58eb1f$export$8b96f5ffd2552cf5(_) {
    return $7a7492651f58eb1f$var$_createMobileConfiguratorElement.apply(this, arguments);
}
function $7a7492651f58eb1f$var$_createMobileConfiguratorElement() {
    $7a7492651f58eb1f$var$_createMobileConfiguratorElement = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, texts, a, anchorElement;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    a = document.createElement("a");
                    a.className = $7a7492651f58eb1f$var$MOBILE_CONFIGURATOR_CLASS;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    a.href = "".concat(window.BH_URL, "/").concat(theme, "/").concat(lang, "?url=").concat(encodeURIComponent(url), "&consultantId=").concat(consultant._id, "&connect=auto&from=mobile-configurator");
                    a.innerHTML = "\n  <span>".concat(texts.mobileConfiguratorButton, "</span>\n  ");
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)(".detail-showcase--img-teaser-box")
                    ];
                case 1:
                    anchorElement = _state.sent();
                    if (anchorElement) $7a7492651f58eb1f$var$insertElement(anchorElement, a);
                    return [
                        2
                    ];
            }
        });
    });
    return $7a7492651f58eb1f$var$_createMobileConfiguratorElement.apply(this, arguments);
}
function $7a7492651f58eb1f$var$insertElement(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement);
    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("MOBILE_CONFIGURATOR_SHOWN");
    var element = document.querySelector(".".concat($7a7492651f58eb1f$var$MOBILE_CONFIGURATOR_CLASS));
    if (element) element.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_MOBILE_CONFIGURATOR_CLICKED");
    };
}
function $7a7492651f58eb1f$export$a968ef38a9c25187(url) {
    return url.match(/\/(flexa|diener|harrison|indivani|opus|modul|navier|flexcube|till|seven)/);
}






var $0838c2706f9d9765$var$ELEMENT_CLASS = "beratungshero--miocolor-product-finder";
function $0838c2706f9d9765$export$ee976956fbd973(_) {
    return $0838c2706f9d9765$var$_createMiocolorProductFinderElement.apply(this, arguments);
}
function $0838c2706f9d9765$var$_createMiocolorProductFinderElement() {
    $0838c2706f9d9765$var$_createMiocolorProductFinderElement = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, texts, a, clearDiv, anchorElement;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    a = document.createElement("a");
                    a.className = $0838c2706f9d9765$var$ELEMENT_CLASS;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    a.href = "".concat(window.BH_URL, "/").concat(theme, "/").concat(lang, "?url=").concat(encodeURIComponent(url), "&consultantId=").concat(consultant._id, "&connect=auto");
                    a.innerHTML = "\n  <span>".concat(texts.stickerButton[theme] || texts.stickerButton.default, "</span>\n  ");
                    clearDiv = document.createElement("div");
                    clearDiv.style = "clear: both;";
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)("#smartassistant-advisor")
                    ];
                case 1:
                    anchorElement = _state.sent();
                    if (anchorElement) {
                        $0838c2706f9d9765$var$insertElement(anchorElement, a);
                        $0838c2706f9d9765$var$insertElement(anchorElement, clearDiv);
                        $0838c2706f9d9765$var$addLogging();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $0838c2706f9d9765$var$_createMiocolorProductFinderElement.apply(this, arguments);
}
function $0838c2706f9d9765$var$insertElement(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement);
}
function $0838c2706f9d9765$var$addLogging() {
    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("MIOCOLOR_PRODUCT_FINDER_SHOWN");
    var element = document.querySelector(".".concat($0838c2706f9d9765$var$ELEMENT_CLASS));
    if (element) element.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("MIOCOLOR_PRODUCT_FINDER_CLICKED");
    };
}
function $0838c2706f9d9765$export$251da56a2383494d(url) {
    return url.match(/\/cp\/produktfinder-malen/);
}





var $78513687fc8146fe$var$THEME = "klubschule";
function $78513687fc8146fe$export$7a3dda2e253d264c(param) {
    var url = param.url, consultant = param.consultant, lang = param.lang;
    var texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
    var div = (0, $34a2da8170297b5a$export$477d3f7871bc78f7)({
        url: url,
        consultant: consultant,
        theme: $78513687fc8146fe$var$THEME,
        lang: lang,
        text: texts.bannerTitle,
        buttonText: "<span>".concat(texts.bannerButton, "</span>")
    });
    (0, $1075a8f80138cc33$export$d16800b7e59a8051)(".ksm-course-static-button").then(function(primaryButton) {
        if (primaryButton) {
            // insert after primaryButton
            primaryButton.parentNode.insertBefore(div, primaryButton.nextSibling);
            (0, $34a2da8170297b5a$export$8e6a1541577e86a7)("BUTTON_BANNER_CLICKED");
        }
    });
}







var $f203296a05b28c3c$var$THEME = "bikeworld";
var $f203296a05b28c3c$var$SIZE_TABLE_ELEMENT_CLASS = "beratungshero-button beratungshero-button--secondary-inverted beratungshero-button--size-table";
function $f203296a05b28c3c$export$7a3dda2e253d264c(param) {
    var url = param.url, consultant = param.consultant, lang = param.lang;
    (0, $e62392e7a88672ed$export$92413a7c60d15e8a)(url, "bikes");
}
function $f203296a05b28c3c$var$createSizeTableElement(_) {
    return $f203296a05b28c3c$var$_createSizeTableElement.apply(this, arguments);
}
function $f203296a05b28c3c$var$_createSizeTableElement() {
    $f203296a05b28c3c$var$_createSizeTableElement = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(param) {
        var url, consultant, theme, lang, texts, a, optionBoxElement, anchorElement;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, consultant = param.consultant, theme = param.theme, lang = param.lang;
                    texts = (0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang);
                    a = document.createElement("a");
                    a.id = "beratungshero-size-table-button";
                    a.className = $f203296a05b28c3c$var$SIZE_TABLE_ELEMENT_CLASS;
                    a.style.marginTop = "-9px";
                    a.style.marginBottom = "16px";
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    a.href = "".concat(window.BH_URL, "/").concat(theme, "/").concat(lang, "?url=").concat(encodeURIComponent(url), "&consultantId=").concat(consultant._id, "&connect=auto&from=size-table");
                    a.innerHTML = "\n  <span>".concat(texts.themeSpecific[$f203296a05b28c3c$var$THEME].sizeTableButton, "</span>\n  ");
                    return [
                        4,
                        (0, $1075a8f80138cc33$export$d16800b7e59a8051)("#detail_variant_option_box")
                    ];
                case 1:
                    optionBoxElement = _state.sent();
                    if (optionBoxElement) {
                        anchorElement = optionBoxElement.nextSibling;
                        if (anchorElement) $f203296a05b28c3c$var$insertElementAfter(anchorElement, a);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $f203296a05b28c3c$var$_createSizeTableElement.apply(this, arguments);
}
function $f203296a05b28c3c$var$insertElementAfter(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement.nextSibling);
    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("SIZE_TABLE_SHOWN");
    var element = document.querySelector("#beratungshero-size-table-button");
    if (element) element.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_SIZE_TABLE_CLICKED");
    };
}





var $81906fdf742fa300$var$liveStreamTimes = [
    {
        from: "2022-08-22T20:00:00+02:00",
        to: "2022-08-22T21:15:00+02:00"
    },
    {
        from: "2022-08-29T20:00:00+02:00",
        to: "2022-08-29T21:30:00+02:00"
    }
];
function $81906fdf742fa300$export$2c1f72e574bfe8b9(tenant, lang) {
    if (tenant !== "sportxx" || lang !== "de") return;
    var url = new URL(document.location.href);
    if (url.searchParams.get("liveStream")) return true;
    if (url.pathname.startsWith("/de")) {
        var now = new Date();
        return $81906fdf742fa300$var$liveStreamTimes.find(function(x) {
            return new Date(x.from) < now && now < new Date(x.to);
        });
    }
}
function $81906fdf742fa300$export$6f843df447d8d0e2(showId) {
    (function() {
        if (!window.initBambuserLiveShopping) {
            window.initBambuserLiveShopping = function(item) {
                window.initBambuserLiveShopping.queue.push(item);
            };
            window.initBambuserLiveShopping.queue = [];
            var scriptNode = document.createElement("script");
            scriptNode["src"] = "https://lcx-embed.bambuser.com/powered-by-bambuser-theme/embed.js";
            document.body.appendChild(scriptNode);
        }
        window.initBambuserLiveShopping({
            showId: showId,
            type: "overlay"
        });
    })();
}
document.body.addEventListener("click", function(e) {
    if (e.target.tagName === "A") {
        var hrefParts = e.target.hash.split("_");
        if (hrefParts[0] === "#vbLiveStream") {
            var id = hrefParts[1];
            console.log("open live stream with id", id);
            $81906fdf742fa300$export$6f843df447d8d0e2(id);
        }
    }
});
// const url = new URL(document.location.href);
// if (url.searchParams.get("vbLiveStream") === "play") {
//   const liveStreamLinks = document.querySelectorAll(
//     "a[href^='#vbLiveStream_']"
//   );
//   if (liveStreamLinks.length > 0) {
//     const hrefParts = liveStreamLinks[0].hash.split("_");
//     const id = hrefParts[1];
//     console.log("open live stream with id", id);
//     initBambuserOverlay(id);
//   }
// }
var $81906fdf742fa300$var$lastTrackingPoint;
var $81906fdf742fa300$var$interval;
var $81906fdf742fa300$var$currentShow;
function $81906fdf742fa300$var$startTrackViewTime(showId) {
    if ($81906fdf742fa300$var$currentShow) {
        if ($81906fdf742fa300$var$currentShow !== showId) $81906fdf742fa300$var$stopTrackViewTime($81906fdf742fa300$var$currentShow);
        else return;
    }
    if ($81906fdf742fa300$var$interval) clearInterval($81906fdf742fa300$var$interval);
    $81906fdf742fa300$var$lastTrackingPoint = new Date().getTime();
    $81906fdf742fa300$var$currentShow = showId;
    $81906fdf742fa300$var$interval = setInterval(function() {
        $81906fdf742fa300$var$trackCurrentProgress(showId);
    }, 15000);
}
function $81906fdf742fa300$var$stopTrackViewTime(showId) {
    if (showId !== $81906fdf742fa300$var$currentShow) return;
    $81906fdf742fa300$var$trackCurrentProgress(showId);
    clearInterval($81906fdf742fa300$var$interval);
    $81906fdf742fa300$var$currentShow = undefined;
    $81906fdf742fa300$var$lastTrackingPoint = undefined;
}
function $81906fdf742fa300$var$trackCurrentProgress(showId) {
    var sendEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (showId !== $81906fdf742fa300$var$currentShow) return;
    var trackingPoint = new Date().getTime();
    var currentWatchTime = parseFloat(window.sessionStorage.getItem("watchTime#" + showId)) || 0;
    var newWatchTime = currentWatchTime + (trackingPoint - $81906fdf742fa300$var$lastTrackingPoint) / 1000;
    $81906fdf742fa300$var$lastTrackingPoint = trackingPoint;
    window.sessionStorage.setItem("watchTime#" + showId, newWatchTime);
    if (sendEvent) $81906fdf742fa300$var$liveStreamEvent({
        eventName: "WATCH_TIME",
        showId: showId,
        value: Math.floor(newWatchTime)
    });
}
function $81906fdf742fa300$var$getCurrentWatchTime(showId) {
    if (showId === $81906fdf742fa300$var$currentShow) $81906fdf742fa300$var$trackCurrentProgress(showId, false);
    return parseInt(window.sessionStorage.getItem("watchTime#" + showId)) || 0;
}
// window.addEventListener("bambuser-liveshop-tracking-point", ({ detail }) => {
//   if (detail.event === "on-play") {
//     startTrackViewTime(detail.data.showId);
//   }
//   if (detail.event === "on-stop") {
//     stopTrackViewTime(detail.data.showId);
//   }
//   if (detail.event === "on-interaction") {
//     if (detail.data.interactionType === "pause") {
//       stopTrackViewTime(detail.data.showId);
//     } else if (detail.data.interactionType === "resume") {
//       startTrackViewTime(detail.data.showId);
//     } else if (detail.data.interactionType === "close") {
//       stopTrackViewTime(detail.data.showId);
//     }
//   }
//   let eventName = toEventName(detail.event).replace(/^ON_/, "");
//   switch (eventName) {
//     case "INTERACTION":
//       eventName = toEventName(detail.data.interactionType);
//   }
//   const watchTime = getCurrentWatchTime(detail.data.showId);
//   liveStreamEvent({
//     eventName,
//     showId: detail.data.showId,
//     value: watchTime ? watchTime : undefined
//   });
// });
// window.addEventListener("message", (e) => {
//   if (e.data) {
//     try {
//       const data = JSON.parse(e.data);
//       if (data.eventName === "liveshopping-widget:tracking") {
//         let eventName = toEventName(data.data.eventType).replace(/^ON_/, "");
//         switch (eventName) {
//           case "INTERACTION":
//             eventName = toEventName(data.data.interactionType);
//         }
//         liveStreamEvent({
//           eventName: "WIDGET_" + eventName,
//           showId: data.data.showId
//         });
//       }
//     } catch (e) {
//       // Ignore if json cannot be parsed
//     }
//   }
// });
function $81906fdf742fa300$var$liveStreamEvent(param) {
    var eventName = param.eventName, showId = param.showId, value = param.value;
    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("LIVESTREAM_" + eventName, {
        showId: showId
    }, value);
}
function $81906fdf742fa300$var$toEventName(value) {
    return value.replace(/[:-]/g, "_").toUpperCase();
}






/**
 * Get the inner html content for the banner.
 * @param {string} avatarImageUrl avatar image url
 * @param {string} beratungsLink beratungs link
 * @param {object} texts translation texts
 * @returns {string} html content
 */ function $79cbe594c1016c18$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts) {
    var isSmartphone = (0, $d547ae2449ccd11b$export$3c89af888305343f)(document.location.href);
    return '\n    <div class="beratungshero--banner beratungshero--banner--pdp">\n      <div class="beratungshero--avatar-container">\n        <img alt="" src="'.concat(avatarImageUrl, '" />\n        <div class="beratungshero--avatar-live">\n          ').concat(texts.widgetLive, '\n        </div>\n      </div>\n      <div class="beratungshero--body beratungshero--body--pdp">\n        <div class="beratungshero--left">\n          <div class="beratungshero--text">\n            <div class="beratungshero--title">\n              ').concat(isSmartphone ? texts.mBudget.banner.title : texts.bannerTitle, '\n            </div>\n            <div class="beratungshero-list">\n              <div class="beratungshero--list-item beratungshero--list-item--pdp">\n                ').concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(texts.widgetBodyBullet1, '\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="beratungshero--buttons beratungshero--buttons--pdp beratungshero--buttons-center">\n          <a id="beratungshero-banner-video" class="beratungshero--more" href="').concat(beratungsLink, '" target="_blank" rel="noopener noreferrer">\n            <span>\n              ').concat(isSmartphone ? texts.mBudget.banner.cta : texts.bannerButton, "\n            </span>\n          </a>\n        </div>\n      </div>\n    </div>");
}
function $79cbe594c1016c18$export$2e2bcd8739ae039(texts, tenant, lang, avatarImageUrl, consultant) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.mBudget.banner.title) throw new Error("texts.mBudget.banner.title is required");
    if (!texts.mBudget.banner.cta) throw new Error("texts.mBudget.banner.cta is required");
    if (!texts.bannerTitle) throw new Error("texts.bannerTitle is required");
    if (!texts.bannerButton) throw new Error("texts.bannerButton is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    if (!texts.widgetBodyBullet1) throw new Error("texts.widgetBodyBullet1 is required");
    if (!lang) throw new Error("lang is required");
    if (!avatarImageUrl) throw new Error("avatarImageUrl is required");
    if (!consultant) throw new Error("consultant is required");
    var urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
    urlParams.append("consultantId", consultant._id);
    var finalLang = lang === "en" ? "de" : lang;
    var beratungsLink = "".concat(window.BH_URL, "/").concat(tenant, "/").concat(finalLang, "?").concat(urlParams.toString());
    var div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = $79cbe594c1016c18$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts);
    return div;
}




/**
 * Create a sticker a tag to inject into the dom.
 * @param {Object} texts
 * @param {string} texts.stickerButton
 * @param {string} texts.widgetLive
 * @param {string} tenant
 * @returns {string}
 * @example
 * getInnerHtmlContent(texts, tenant);
 * @example
 * getInnerHtmlContent(texts, "bikeworld");
 */ function $8793c0b3ea70f5c6$var$getInnerHtmlContent(texts, tenant) {
    return "<span>".concat(texts.stickerButton[tenant] || texts.stickerButton.default, '</span><span class="beratungshero--sticker-live">').concat(texts.widgetLive, '</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>');
}
function $8793c0b3ea70f5c6$export$2e2bcd8739ae039(texts, tenant) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.stickerButton) throw new Error("texts.stickerButton is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    var a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = $8793c0b3ea70f5c6$var$getInnerHtmlContent(texts, tenant);
    a.onclick = function() {
        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_STICKER_CLICKED");
        (0, $1075a8f80138cc33$export$5009e7f3fa7b4cd3)("beratungshero_button_sticker_clicked");
    };
    return a;
}



/**
 * Get the inner html content for the wishlist banner.
 * @param {string} avatarImageUrl avatar image url
 * @param {string} beratungsLink beratungs link
 * @param {object} texts translation texts
 * @returns {string} html content
 */ function $de7b8cc1b26e002f$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts) {
    var div = document.createElement("div");
    div.className = "wishlist--container";
    div.innerHTML = '\n  <div class="beratungshero--banner">\n    <div class="beratungshero--avatar-container">\n      <img alt="" src="'.concat(avatarImageUrl, '" />\n      <div class="beratungshero--avatar-live">').concat(texts.widgetLive, '</div>\n    </div>\n    <div class="beratungshero--body">\n      <div class="beratungshero--left">\n        <div class="beratungshero--text">\n          <div class="beratungshero--title">\n            ').concat(texts.wishlistTitle, '\n          </div>\n          <div class="beratungshero-list">\n            <div class="beratungshero--list-item">\n              ').concat((0, $0b748888cf77b1cd$export$ead18583963a4390), " ").concat(texts.widgetBodyBullet1, '\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="beratungshero--buttons beratungshero--buttons-center">\n        <a id="beratungshero-banner-video" class="beratungshero--more" href="').concat(beratungsLink, '" target="_blank" rel="noopener noreferrer">\n          <span>').concat(texts.wishlistButton, "</span>\n        </a>\n      </div>\n    </div>\n  </div>\n  ");
    return div;
}
function $de7b8cc1b26e002f$export$2e2bcd8739ae039(texts, tenant, lang, avatarImageUrl, consultantId) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    if (!texts.wishlistTitle) throw new Error("texts.wishlistTitle is required");
    if (!texts.widgetBodyBullet1) throw new Error("texts.widgetBodyBullet1 is required");
    if (!texts.wishlistButton) throw new Error("texts.wishlistButton is required");
    if (!lang) throw new Error("lang is required");
    if (!avatarImageUrl) throw new Error("avatarImageUrl is required");
    var urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
    urlParams.append("consultantId", consultantId);
    var finalLang = lang === "en" ? "de" : lang;
    var beratungsLink = "".concat(window.BH_URL, "/").concat(tenant, "/").concat(finalLang, "?").concat(urlParams.toString());
    var wishlistBanner = document.createElement("div");
    wishlistBanner.appendChild($de7b8cc1b26e002f$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts));
    return wishlistBanner;
}


/**
 * Cached data from the last widget data fetch. It contains the widget data and the timestamp of the fetch.
 * @type {Object}
 * @property {Object} data - The widget data.
 * @property {string} lang - The language of the widget data.
 * @property {number} timestamp - The timestamp of the fetch.
 */ 

var $3240839f54a9efa8$var$cachedData;
function $3240839f54a9efa8$export$2e2bcd8739ae039(lang, tenant) {
    return $3240839f54a9efa8$var$_loadWidgetData.apply(this, arguments);
}
function $3240839f54a9efa8$var$_loadWidgetData() {
    $3240839f54a9efa8$var$_loadWidgetData = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(lang, tenant) {
        var data, error;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!("fetch" in window)) return [
                        2
                    ];
                    // Check if we have cached data and that the cached data is not to old and of the same language. If the check is true we return the cached data.
                    if ($3240839f54a9efa8$var$cachedData && $3240839f54a9efa8$var$cachedData.lang === lang && $3240839f54a9efa8$var$cachedData.timestamp + 120000 > Date.now()) return [
                        2,
                        $3240839f54a9efa8$var$cachedData.data
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch("".concat(window.BH_URL, "/api/widget-enabled?rootTheme=").concat(tenant, "&theme=").concat(tenant, "&lang=").concat(lang))
                    ];
                case 2:
                    return [
                        4,
                        _state.sent().json()
                    ];
                case 3:
                    data = _state.sent();
                    $3240839f54a9efa8$var$cachedData = {
                        data: data,
                        lang: lang,
                        timestamp: Date.now()
                    };
                    return [
                        2,
                        $3240839f54a9efa8$var$cachedData.data
                    ];
                case 4:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $3240839f54a9efa8$var$_loadWidgetData.apply(this, arguments);
}


var $23e82d53be12b7b0$export$6242eb21763d4a88 = [
    "bikeworld",
    "doitgarden",
    "micasa",
    "melectronics",
    "sportxx",
    "sportx"
];




function $408cce66cb10dc76$export$2e2bcd8739ae039(anchor, config) {
    if (!anchor) throw new Error("No anchor element provided.");
    if (!config) throw new Error("No config object provided.");
    if (!config.lang) throw new Error("No language provided.");
    if (!config.tenant) throw new Error("No tenant provided.");
    if (!(0, $23e82d53be12b7b0$export$6242eb21763d4a88).includes(config.tenant)) throw new Error("Invalid tenant provided.");
}






function $647bfed1b685b2a2$export$2e2bcd8739ae039(anchor, config) {
    return $647bfed1b685b2a2$var$_renderBanner.apply(this, arguments);
}
function $647bfed1b685b2a2$var$_renderBanner() {
    $647bfed1b685b2a2$var$_renderBanner = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(anchor, config) {
        var lang, tenant, _ref, consultant, duringOfficeHours, consultantAvailable, tenantData, touchpoints, avatarImageUrl, banner, moreLink, err;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $408cce66cb10dc76$export$2e2bcd8739ae039)(anchor, config);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    lang = config.lang, tenant = config.tenant;
                    if ((0, $1075a8f80138cc33$export$bfb231a5a6aca5de)(tenant)) return [
                        2
                    ];
                    return [
                        4,
                        (0, $3240839f54a9efa8$export$2e2bcd8739ae039)(lang, tenant)
                    ];
                case 2:
                    _ref = _state.sent(), consultant = _ref.consultant, duringOfficeHours = _ref.duringOfficeHours, consultantAvailable = _ref.consultantAvailable, tenantData = _ref.tenant;
                    touchpoints = tenantData.touchpoints;
                    if (touchpoints && touchpoints.banner && touchpoints.banner.enabled !== undefined && !touchpoints.banner.enabled) return [
                        2
                    ];
                    if (!duringOfficeHours || !consultantAvailable) return [
                        2
                    ];
                    if (!consultant || !consultant._id) throw new Error("No consultant found");
                    avatarImageUrl = consultant.imageAvatar;
                    if (avatarImageUrl.indexOf("https://") === 0) avatarImageUrl = avatarImageUrl.replace("upload/", "upload/w_240/");
                    else avatarImageUrl = window.BH_URL + avatarImageUrl;
                    banner = (0, $79cbe594c1016c18$export$2e2bcd8739ae039)((0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang), tenant, lang, avatarImageUrl, consultant);
                    anchor.appendChild(banner);
                    moreLink = document.querySelector("#beratungshero-banner-video");
                    moreLink.onclick = function() {
                        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_BANNER_CLICKED");
                    };
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $647bfed1b685b2a2$var$_renderBanner.apply(this, arguments);
}







function $b438e61da2852e7a$export$2e2bcd8739ae039(anchor, config) {
    return $b438e61da2852e7a$var$_renderSticker.apply(this, arguments);
}
function $b438e61da2852e7a$var$_renderSticker() {
    $b438e61da2852e7a$var$_renderSticker = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(anchor, config) {
        var lang, tenant, _ref, consultant, duringOfficeHours, consultantAvailable, tenantData, touchpoints, sticker, urlParams, finalLang, error;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $408cce66cb10dc76$export$2e2bcd8739ae039)(anchor, config);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    lang = config.lang, tenant = config.tenant;
                    if ((0, $1075a8f80138cc33$export$bfb231a5a6aca5de)(tenant)) return [
                        2
                    ];
                    return [
                        4,
                        (0, $3240839f54a9efa8$export$2e2bcd8739ae039)(lang, tenant)
                    ];
                case 2:
                    _ref = _state.sent(), consultant = _ref.consultant, duringOfficeHours = _ref.duringOfficeHours, consultantAvailable = _ref.consultantAvailable, tenantData = _ref.tenant;
                    touchpoints = tenantData.touchpoints;
                    if (touchpoints && touchpoints.sticker && touchpoints.sticker.enabled !== undefined && !touchpoints.sticker.enabled) return [
                        2
                    ];
                    if (!duringOfficeHours || !consultantAvailable) return [
                        2
                    ];
                    if (!consultant || !consultant._id) throw new Error("No consultant found");
                    sticker = (0, $8793c0b3ea70f5c6$export$2e2bcd8739ae039)((0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang), tenant);
                    urlParams = new URLSearchParams();
                    urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
                    urlParams.append("consultantId", consultant._id);
                    urlParams.append("source", "sticker");
                    finalLang = lang === "en" ? "de" : lang;
                    sticker.href = "".concat(window.BH_URL, "/").concat(tenant, "/").concat(finalLang, "?").concat(urlParams.toString());
                    anchor.appendChild(sticker);
                    (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("STICKER_SHOWN");
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $b438e61da2852e7a$var$_renderSticker.apply(this, arguments);
}







function $60af51d54ca6b260$export$2e2bcd8739ae039(anchor, config) {
    return $60af51d54ca6b260$var$_renderWishlistBanner.apply(this, arguments);
}
function $60af51d54ca6b260$var$_renderWishlistBanner() {
    $60af51d54ca6b260$var$_renderWishlistBanner = (0, $68c4eca8780e0866$export$71511d61b312f219)(function(anchor, config) {
        var lang, tenant, _ref, consultant, duringOfficeHours, consultantAvailable, avatarImageUrl, banner, moreLink, err;
        return (0, $71c98a0c5b40ff86$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $408cce66cb10dc76$export$2e2bcd8739ae039)(anchor, config);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    lang = config.lang, tenant = config.tenant;
                    if ((0, $1075a8f80138cc33$export$bfb231a5a6aca5de)(tenant)) return [
                        2
                    ];
                    return [
                        4,
                        (0, $3240839f54a9efa8$export$2e2bcd8739ae039)(lang, tenant)
                    ];
                case 2:
                    _ref = _state.sent(), consultant = _ref.consultant, duringOfficeHours = _ref.duringOfficeHours, consultantAvailable = _ref.consultantAvailable;
                    if (!duringOfficeHours || !consultantAvailable) return [
                        2
                    ];
                    if (!consultant || !consultant._id) throw new Error("No consultant found");
                    avatarImageUrl = consultant.imageAvatar;
                    if (avatarImageUrl.indexOf("https://") === 0) avatarImageUrl = avatarImageUrl.replace("upload/", "upload/w_240/");
                    else avatarImageUrl = window.BH_URL + avatarImageUrl;
                    banner = (0, $de7b8cc1b26e002f$export$2e2bcd8739ae039)((0, $d547ae2449ccd11b$export$f25f608cf887c8b)(lang), tenant, lang, avatarImageUrl, consultant._id);
                    anchor.appendChild(banner);
                    moreLink = document.querySelector("#beratungshero-banner-video");
                    moreLink.onclick = function() {
                        (0, $d547ae2449ccd11b$export$5e9eec8001665ac5)("BUTTON_WISHLIST_CLICKED");
                    };
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $60af51d54ca6b260$var$_renderWishlistBanner.apply(this, arguments);
}




var $d547ae2449ccd11b$var$DEBUG = false;
var $d547ae2449ccd11b$var$POPUP_ENLARGED_COOKIE_NAME = "onlineberatung-enlarged";
var $d547ae2449ccd11b$var$THROTTLED_COOKIE_NAME = "onlineberatung-throttled";
var $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_DEFAULT = 30000;
var $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_PRODUCT = 3000000;
var $d547ae2449ccd11b$var$from = null;
window.BH_BAMBUSER_CLOSE = false;
window.addEventListener("message", function(e) {
    if (e.data === "BH_BAMBUSER_CLOSED") {
        window.BH_BAMBUSER_CLOSE = true;
        $d547ae2449ccd11b$var$currentUrl = document.location.href.split("#")[0];
        var _getThemeAndLang = $d547ae2449ccd11b$var$getThemeAndLang($d547ae2449ccd11b$var$currentUrl), theme = _getThemeAndLang.theme, lang = _getThemeAndLang.lang;
        $d547ae2449ccd11b$var$handlePageChange({
            url: $d547ae2449ccd11b$var$currentUrl,
            delay: $d547ae2449ccd11b$var$delay,
            theme: theme,
            lang: lang
        });
    }
});
function $d547ae2449ccd11b$var$supportsWebRTC() {
    var isWebRTCSupported = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || window.RTCPeerConnection;
    if (window.navigator.userAgent.indexOf("Edge") > -1) return false;
    if (isWebRTCSupported) return true;
    else return false;
}
function $d547ae2449ccd11b$export$5e9eec8001665ac5(event) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, value = arguments.length > 2 ? arguments[2] : void 0;
    var evt = {
        event: "beratungshero",
        beratungsheroEvent: event,
        beratungsheroOption: options ? Object.values(options).join(",") : undefined,
        beratungsheroValue: value || undefined
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evt);
    if ($d547ae2449ccd11b$var$DEBUG) console.log(event);
}
function $d547ae2449ccd11b$export$f25f608cf887c8b(lang) {
    switch(lang){
        case "fr":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b3a234f48cdbaf79$exports));
        case "it":
            return 0, (/*@__PURE__*/$parcel$interopDefault($63036b4732656168$exports));
        case "en":
            return 0, (/*@__PURE__*/$parcel$interopDefault($81267ec388b1673b$exports));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($82d7d99f625a9d8d$exports));
    }
}
function $d547ae2449ccd11b$export$3c89af888305343f(url) {
    var isOfCategory = false;
    if ((0, $e62392e7a88672ed$export$a6ee0f0139d9689a)(url) && window.dataLayer) window.dataLayer.forEach(function(item) {
        if (item.ecommerce && item.ecommerce.impressions) {
            var categoryUrl = item.ecommerce.impressions[0].category;
            if (categoryUrl.match("/smartphone")) isOfCategory = true;
        }
    });
    if (isOfCategory) return true;
    return url.match(/\/(smartphone)/);
}
function $d547ae2449ccd11b$var$isBannedPage(url, theme, lang) {
    var banned = false;
    if ((0, $e62392e7a88672ed$export$ab20bca5abfae9b7)(url)) banned = true;
    if ((0, $e62392e7a88672ed$export$a6ee0f0139d9689a)(url) && window.dataLayer) window.dataLayer.forEach(function(item) {
        if (item.ecommerce && item.ecommerce.detail && item.ecommerce.detail.products && item.ecommerce.detail.products[0] && item.ecommerce.detail.products[0].category) {
            var categoryUrl = item.ecommerce.detail.products[0].category;
            if (categoryUrl.match("/lust-liebe") || categoryUrl.match("/spielwaren")) banned = true;
        }
    });
    if ((0, $e62392e7a88672ed$export$3ee1ac535276712)(url)) banned = true;
    if (banned) return true;
    if ($d547ae2449ccd11b$var$hasLiveShoppingElement()) return true;
    if ((0, $81906fdf742fa300$export$2c1f72e574bfe8b9)(theme, lang)) return true;
    // check if we are on heimberatung or einrichtungsberatung page and lang is not de to hide widget
    var isUrlEinrichtungOrHeimberatung = url.match(/\/(einrichtungsberatung)/) || url.match(/\/(heimberatung)/);
    if (isUrlEinrichtungOrHeimberatung && lang !== "de") return true;
    // Check if we are in an iframe, e.g. when the mini-player is active
    if (!window.BH_BAMBUSER_CLOSE && window.self !== window.top) return true;
    return url.match(/\/(cart|checkout|contact|storefinder|lust-liebe|plaisir-et-amour|Singles-Day|singles-day|spielwaren|dailydeal|big-win)/);
}
function $d547ae2449ccd11b$var$hasLiveShoppingElement() {
    return !!document.querySelector(".liveShopping");
}
var $d547ae2449ccd11b$var$updateRichrelevanceFeedInterval;
var $d547ae2449ccd11b$var$miocolorWidgetCreated = false;
function $d547ae2449ccd11b$var$handlePageChange(param) {
    var url = param.url, delay = param.delay, theme = param.theme, lang = param.lang;
    var root = document.querySelector(".beratungshero--root");
    var hide = $d547ae2449ccd11b$var$isBannedPage(url, theme, lang);
    // if (isLiveStreamActive(theme, lang)) {
    //   initBambuserFloatingButton();
    // }
    if (root) {
        root.style.display = hide ? "none" : "block";
        if (hide) return;
    }
    // Handle change to miocolor theme
    var _getThemeAndLang = $d547ae2449ccd11b$var$getThemeAndLang(url), newTheme = _getThemeAndLang.theme, newLang = _getThemeAndLang.lang;
    theme = newTheme;
    lang = newLang;
    if ($d547ae2449ccd11b$var$isThrottled()) return;
    $d547ae2449ccd11b$var$checkIfEnabled(function(consultant, booking, bookingLink, landingPageUrl, tenant) {
        var _window_BH, _window;
        var theme = tenant.name;
        // check if changing from booking to normal widget or vice versa
        var bookingWidgetShown = !!document.querySelector(".beratungshero--booking");
        if (consultant && bookingWidgetShown || booking && !bookingWidgetShown) // remove widget, right widget is added below
        {
            if (root) {
                root.remove();
                root = null;
                (0, $6c8329843422652c$export$eb1d1800c11907c2)();
                $d547ae2449ccd11b$var$stylesAdded = false;
            }
        }
        if ($d547ae2449ccd11b$var$isBannedPage(url, theme, lang) && root) {
            root.style.display = "none";
            return;
        }
        var widgetPosition = (_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.widgetPosition;
        if (theme === "miocolor") {
            if (!hide) $d547ae2449ccd11b$export$5e9eec8001665ac5("MIOCOLOR_WIDGET_SHOWN");
            if (!$d547ae2449ccd11b$var$miocolorWidgetCreated) {
                if (root) {
                    root.remove();
                    root = null;
                    (0, $6c8329843422652c$export$eb1d1800c11907c2)();
                    $d547ae2449ccd11b$var$stylesAdded = false;
                }
                if (!$d547ae2449ccd11b$var$stylesAdded) {
                    (0, $6c8329843422652c$export$31f077b88a3c784c)(theme, lang);
                    $d547ae2449ccd11b$var$stylesAdded = true;
                }
                var variant = $d547ae2449ccd11b$var$getVariant(theme);
                (0, $f2df12b8418717de$export$d856f5947026c431)({
                    consultant: consultant,
                    theme: theme,
                    lang: lang,
                    variant: variant,
                    hidden: hide,
                    booking: booking,
                    bookingLink: bookingLink,
                    landingPageUrl: landingPageUrl,
                    tenant: tenant,
                    position: widgetPosition,
                    widgetType: window.BH.widgetType,
                    popupVideoUrl: window.BH.popupVideoUrl,
                    from: $d547ae2449ccd11b$var$from,
                    url: url
                });
                $d547ae2449ccd11b$var$miocolorWidgetCreated = true;
            } else $d547ae2449ccd11b$var$updatePopupPrimaryButtonShopUrl();
        } else {
            if ($d547ae2449ccd11b$var$miocolorWidgetCreated) {
                if (root) {
                    root.remove();
                    root = null;
                    $d547ae2449ccd11b$var$miocolorWidgetCreated = false;
                    (0, $6c8329843422652c$export$eb1d1800c11907c2)();
                    $d547ae2449ccd11b$var$stylesAdded = false;
                }
            }
            if (!root) {
                if (!hide) $d547ae2449ccd11b$export$5e9eec8001665ac5("WIDGET_SHOWN");
                if (booking) {
                    if (!hide) $d547ae2449ccd11b$export$5e9eec8001665ac5("WIDGET_APPOINTMENT_SHOWN");
                }
                if (!$d547ae2449ccd11b$var$stylesAdded) {
                    (0, $6c8329843422652c$export$31f077b88a3c784c)(theme, lang);
                    $d547ae2449ccd11b$var$stylesAdded = true;
                }
                var variant1 = $d547ae2449ccd11b$var$getVariant(theme);
                (0, $f2df12b8418717de$export$d856f5947026c431)({
                    consultant: consultant,
                    theme: theme,
                    lang: lang,
                    variant: variant1,
                    hidden: hide,
                    booking: booking,
                    bookingLink: bookingLink,
                    landingPageUrl: landingPageUrl,
                    tenant: tenant,
                    position: widgetPosition,
                    widgetType: window.BH.widgetType,
                    popupVideoUrl: window.BH.popupVideoUrl,
                    from: $d547ae2449ccd11b$var$from,
                    url: url
                });
            } else $d547ae2449ccd11b$var$updatePopupPrimaryButtonShopUrl();
        }
        switch(theme){
            case "klubschule":
                (0, $78513687fc8146fe$export$7a3dda2e253d264c)({
                    url: url,
                    consultant: consultant,
                    lang: lang
                });
                break;
            case "bikeworld":
                (0, $f203296a05b28c3c$export$7a3dda2e253d264c)({
                    url: url,
                    consultant: consultant,
                    lang: lang
                });
                break;
        }
        if ($d547ae2449ccd11b$var$updateRichrelevanceFeedInterval) clearInterval($d547ae2449ccd11b$var$updateRichrelevanceFeedInterval);
        if (!booking && (0, $e62392e7a88672ed$export$a6ee0f0139d9689a)(url)) $d547ae2449ccd11b$var$updateRichrelevanceFeedInterval = setInterval($d547ae2449ccd11b$var$updateRichrelevanceFeed, 5000);
        if (theme === "klubschule") {
            $d547ae2449ccd11b$var$enlargePopup({
                delay: $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_DEFAULT,
                theme: theme,
                lang: lang
            });
            return;
        }
        if (theme === "melectronics" && $d547ae2449ccd11b$export$3c89af888305343f(url)) {
            $d547ae2449ccd11b$var$enlargePopup({
                delay: $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_DEFAULT,
                theme: theme,
                lang: lang
            });
            return;
        }
        var uri = new URL(url);
        if (theme === "micasa" && uri.href.includes("einrichtungsberatung")) $d547ae2449ccd11b$var$enlargePopup({
            delay: 10000,
            theme: theme,
            lang: lang
        });
        if (theme === "micasa" && uri.href.includes("heimberatung")) $d547ae2449ccd11b$var$enlargePopup({
            delay: 10000,
            theme: theme,
            lang: lang
        });
        if ((0, $e62392e7a88672ed$export$47b4274c3eda8f60)(url) && !booking) {
            (0, $34a2da8170297b5a$export$25c216e52ab8fda1)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if ((0, $e62392e7a88672ed$export$fe63f8185eda093c)(url) && !booking) {
            (0, $34a2da8170297b5a$export$34b442c3d073f811)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if (theme === "miocolor" && (0, $0838c2706f9d9765$export$251da56a2383494d)(url)) {
            (0, $0838c2706f9d9765$export$ee976956fbd973)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if ((0, $e62392e7a88672ed$export$a6ee0f0139d9689a)(url) && !$d547ae2449ccd11b$var$isBannedPage(url, theme, lang)) {
            // enlarge popup also for booking appointment
            $d547ae2449ccd11b$var$enlargePopup({
                delay: delay,
                theme: theme,
                lang: lang
            });
            if (!booking) {
                $d547ae2449ccd11b$var$logOptimizeEvent("optimize.sticker.show");
                (0, $a2a40aec03e6bc02$export$752ff9cccbcd133d)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
                (0, $34a2da8170297b5a$export$596743d694fcb1b6)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
                if (theme === "micasa" && $d547ae2449ccd11b$var$isMobile() && (0, $7a7492651f58eb1f$export$a968ef38a9c25187)(url)) (0, $7a7492651f58eb1f$export$8b96f5ffd2552cf5)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
            }
        }
    }, theme, lang, url);
}
function $d547ae2449ccd11b$var$enlargePopup(param) {
    var delay = param.delay;
    if (window.BH.popupVideoUrl !== null) (0, $f2df12b8418717de$export$ae6c4758b5042ef8)();
    $d547ae2449ccd11b$var$timer = setTimeout(function() {
        var widget = document.querySelector(".beratungshero--root .beratungshero--popup");
        if (widget) {
            // Show popup
            var enlarged = (0, (/*@__PURE__*/$parcel$interopDefault($2f23a94a28b6e759$exports))).get($d547ae2449ccd11b$var$POPUP_ENLARGED_COOKIE_NAME);
            if (!enlarged && !window.BH.widgetBig) {
                (0, $f2df12b8418717de$export$cfae72848eff8ed2)();
                widget.style.transform = "scale(1)";
                var avatar = document.querySelector(".beratungshero--avatar");
                avatar.querySelector(".beratungshero--avatar-img").classList.remove("beratungshero--avatar-pulse");
                window.BH.widgetClosed = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($2f23a94a28b6e759$exports))).set($d547ae2449ccd11b$var$POPUP_ENLARGED_COOKIE_NAME, true);
                window.BH.widgetBig = true;
            }
        }
    }, delay);
}
var $d547ae2449ccd11b$var$currentUrl = document.location.href.split("#")[0];
var $d547ae2449ccd11b$var$stylesAdded = false;
if (!window.BH) window.BH = {
    widgetBig: false,
    widgetClosed: true
};
window.BH["renderSticker"] = (0, $b438e61da2852e7a$export$2e2bcd8739ae039);
window.BH["renderBanner"] = (0, $647bfed1b685b2a2$export$2e2bcd8739ae039);
window.BH["renderWishlistBanner"] = (0, $60af51d54ca6b260$export$2e2bcd8739ae039);
var $d547ae2449ccd11b$var$timer;
function $d547ae2449ccd11b$var$getParam(url, name) {
    return new URL(url).searchParams.get(name);
}
function $d547ae2449ccd11b$var$checkIfEnabled(callback, theme, lang, url) {
    var handleWidgetEnabledResponse = function(data) {
        var enabled = data.enabled, error = data.error, booking = data.booking, bookingLink = data.bookingLink, duringOfficeHours = data.duringOfficeHours, consultantAvailable = data.consultantAvailable, consultant = data.consultant, landingPageUrl = data.landingPageUrl, tenant = data.tenant;
        var throttled;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2f23a94a28b6e759$exports))).get($d547ae2449ccd11b$var$THROTTLED_COOKIE_NAME) === undefined) {
            throttled = Math.floor(Math.random() * 100) > tenant.throttlingRatio * 100;
            (0, (/*@__PURE__*/$parcel$interopDefault($2f23a94a28b6e759$exports))).set($d547ae2449ccd11b$var$THROTTLED_COOKIE_NAME, throttled);
        } else throttled = $d547ae2449ccd11b$var$isThrottled();
        if (throttled) // don't call callback
        return;
        // todo better solution for landing pages
        var landingPageUrl2;
        if (landingPageUrl) landingPageUrl2 = landingPageUrl.replace(/\/de\//, "/".concat(lang, "/"));
        else landingPageUrl2 = tenant.landingPageUrls[lang];
        if ((0, $1075a8f80138cc33$export$bfb231a5a6aca5de)(theme)) return;
        if (!error && enabled) {
            if (duringOfficeHours && consultantAvailable) {
                $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.show");
                $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show");
                if (tenant.name === "sportxx" || tenant.name === "sportx") {
                    if (url.match(/\/bekleidung-schuhe\/bekleidung/) || url.match(/\/ausruestung\/trekking-zubehoer/) || url.match(/\/ausruestung\/rucksaecke/) || (0, $e62392e7a88672ed$export$8bcfff33a6c98fa4)(url, [
                        "bekleidung-schuhe/bekleidung",
                        "ausruestung/trekking-zubehoer",
                        "ausruestung/rucksaecke"
                    ])) {
                        console.log("log optimize outdoor");
                        $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show.outdoor");
                    } else if (url.match(/\/sports\/fitness/) || url.match(/\/ausruestung\/fitness/) || (0, $e62392e7a88672ed$export$8bcfff33a6c98fa4)(url, [
                        "sports/fitness",
                        "ausruestung/fitness-zubehoer",
                        "ausruestung/fitnessgeraete"
                    ])) {
                        console.log("log optimize fitness");
                        $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show.fitness");
                    } else if (url.match(/\/sports\/running/) || (0, $e62392e7a88672ed$export$8bcfff33a6c98fa4)(url, [
                        "sports/running"
                    ])) {
                        console.log("log optimize running");
                        $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show.running");
                    } else if (url.match(/\/sports\/ski/) || url.match(/\/ausruestung\/ski/) || url.match(/\/ausruestung\/snow/) || (0, $e62392e7a88672ed$export$8bcfff33a6c98fa4)(url, [
                        "ausruestung/langlaufschuhe",
                        "ausruestung/langlaufski",
                        "ausruestung/schlitten-bobs",
                        "ausruestung/schlittschuhe",
                        "ausruestung/schneeschuhe",
                        "ausruestung/ski",
                        "ausruestung/skischuhe",
                        "ausruestung/snowboard",
                        "ausruestung/snowboard-bindungen",
                        "ausruestung/snowboardschuhe",
                        "ausruestung/stoecke",
                        "ausruestung/tourenzubehoer"
                    ])) {
                        console.log("log optimize ski");
                        $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show.ski");
                    } else $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.call.show.neutral");
                }
                callback(consultant, false, bookingLink, landingPageUrl2, tenant);
            } else {
                if (booking && lang !== "it") {
                    $d547ae2449ccd11b$var$logOptimizeEvent("optimize.widget.show");
                    callback(null, true, bookingLink, landingPageUrl2, tenant);
                } else if (tenant.fallbackTenantName) {
                    $d547ae2449ccd11b$var$from = tenant.name;
                    (0, $cbe0397808b0ae7d$export$85fae2512280f40b)(tenant.fallbackTenantName, lang).then(function(res) {
                        res.json().then(handleWidgetEnabledResponse);
                    });
                } else {
                    // remove widget
                    var root = document.querySelector(".beratungshero--root");
                    if (root) root.remove();
                }
            }
        }
    };
    (0, $cbe0397808b0ae7d$export$85fae2512280f40b)(theme, lang).then(function(res) {
        res.json().then(handleWidgetEnabledResponse);
    });
}
function $d547ae2449ccd11b$var$getThemeAndLang(url) {
    if (url.match(/klubschule.ch/)) return {
        theme: "klubschule",
        lang: "de"
    };
    else if (url.match(/ecole-club.ch/)) return {
        theme: "klubschule",
        lang: "fr"
    };
    else if (url.match(/scuola-club.ch/)) return {
        theme: "klubschule",
        lang: "it"
    };
    var match = url.match(/(bikeworld|doitgarden|micasa|melectronics|sportx).ch\/(de|fr|it)/);
    if (match) {
        var _match = (0, $595c5a81428bb48a$export$71511d61b312f219)(match, 3), theme = _match[1], lang = _match[2];
        if ($d547ae2449ccd11b$var$showMiocolorWidget(url, theme, lang)) return {
            theme: "miocolor",
            lang: lang
        };
        // navigator.language references Browser UI language instead of
        // Accept-Language header in Chrome & Edge Chromium
        // https://caniuse.com/mdn-api_navigatorlanguage_language
        if ((navigator.language || "").startsWith("en")) {
            $d547ae2449ccd11b$var$logOptimizeEvent("optimize.browser.en");
            if (!!window.BH.englishJourney // is set by Optimize
            ) return {
                theme: theme,
                lang: "en"
            };
        }
        return {
            theme: theme,
            lang: lang
        };
    }
    return {
        theme: null,
        lang: null
    };
}
var $d547ae2449ccd11b$var$delay = window.BH.enlargePopupDelayProduct || $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_PRODUCT;
function $d547ae2449ccd11b$var$checkIfShown() {
    var url = $d547ae2449ccd11b$var$currentUrl;
    var delay = window.BH.enlargePopupDelayProduct || $d547ae2449ccd11b$var$ENLARGE_POPUP_DELAY_PRODUCT;
    if (url.match("localhost") || url.match("ngrok")) {
        url = "https://www.sportx.ch/de/f/aktionensd?q=%3Arelevance%3Aspecial%3AAktion";
        // "https://www.melectronics.ch/de/p/794687500000/samsung-galaxy-a13-128gb-black";
        //"https://www.bikeworld.ch/de?gclid=CjwKCAjw4ayUBhA4EiwATWyBrpbiEp7R2TQpC2_tC2xH2j3voqDHIMp2aPhKmd58WipqFnDylBjFzhoCPPcQAvD_BwE&gclsrc=aw.ds";
        delay = 1000;
        if (!window.dataLayer) window.dataLayer = [];
        window.dataLayer.push({
            event: "productImpression",
            ecommerce: {
                currencyCode: "CHF",
                recommTool: "custom",
                productCount: 65,
                impressions: [
                    {
                        uniqueProductId: "794687500000",
                        price: "189",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: true,
                        position: 1,
                        productURL: "https://www.melectronics.ch/de/p/794687500000/samsung-galaxy-a13-128gb-black",
                        productImageURL: "https://image.migros.ch/original/eba29be15be85e1e38e404909b709dde72c3e4d2/samsung-galaxy-a13-128gb-black-smartphone.jpg",
                        name: "Galaxy A13 128GB Black",
                        id: "794687500000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        oldPrice: "209",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794687400000",
                        price: "369",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 2,
                        productURL: "https://www.melectronics.ch/de/p/794687400000/samsung-galaxy-a33-5g-128gb-awesome-black",
                        productImageURL: "https://image.migros.ch/original/666ad40dc9535b2a90e6beff80ffc241da69dd88/samsung-galaxy-a33-5g-128gb-awesome-black-smartphone.jpg",
                        name: "Galaxy A33 5G 128GB Awesome Black",
                        id: "794687400000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794687300000",
                        price: "449",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 3,
                        productURL: "https://www.melectronics.ch/de/p/794687300000/samsung-galaxy-a53-5g-128gb-awesome-black",
                        productImageURL: "https://image.migros.ch/original/cc92b9347c2fc652dd7c065cde2435e941bc3c7f/samsung-galaxy-a53-5g-128gb-awesome-black-smartphone.jpg",
                        name: "Galaxy A53 5G 128GB Awesome Black",
                        id: "794687300000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794675000000",
                        price: "549",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 4,
                        productURL: "https://www.melectronics.ch/de/p/794675000000/samsung-galaxy-s21-fe-5g-128gb-graphite",
                        productImageURL: "https://image.migros.ch/original/2534d1f3f83af8b957efa673b450363cc35480ff/samsung-galaxy-s21-fe-5g-128gb-graphite-smartphone.jpg",
                        name: "Galaxy S21 FE 5G 128GB Graphite",
                        id: "794675000000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794683600000",
                        price: "749",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 5,
                        productURL: "https://www.melectronics.ch/de/p/794683600000/samsung-galaxy-s22-128gb-phantom-black",
                        productImageURL: "https://image.migros.ch/original/32d222db7eb1f6fe84eb37542625859890458846/samsung-galaxy-s22-128gb-phantom-black-smartphone.jpg",
                        name: "Galaxy S22 128GB Phantom Black",
                        id: "794683600000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    }
                ]
            },
            "gtm.uniqueEventId": 25
        });
    }
    var isWebRTCSupported = $d547ae2449ccd11b$var$supportsWebRTC();
    if (!isWebRTCSupported) return;
    // don't show widget for consultants
    if ($d547ae2449ccd11b$var$getParam(url, "hidewidget") === "true") return;
    var utm_campaign = $d547ae2449ccd11b$var$getParam(url, "utm_campaign");
    // Bei Aufforderung für Bewertung nach Kauf, Widget nicht anzeigen
    if (utm_campaign && utm_campaign.toLowerCase().startsWith("kun-01")) return;
    var _getThemeAndLang = $d547ae2449ccd11b$var$getThemeAndLang(url), theme = _getThemeAndLang.theme, lang = _getThemeAndLang.lang;
    console.log("theme", theme, "lang", lang);
    if (!theme) return;
    // logEvent(variant === 1 ? "POPUP_VARIANT_A" : "POPUP_VARIANT_B");
    $d547ae2449ccd11b$var$handlePageChange({
        url: url,
        delay: delay,
        theme: theme,
        lang: lang
    });
    setInterval(function() {
        if (document.location.href.split("#")[0] !== $d547ae2449ccd11b$var$currentUrl) {
            $d547ae2449ccd11b$var$currentUrl = document.location.href.split("#")[0];
            // clear previous trigger to enlarge popup
            clearTimeout($d547ae2449ccd11b$var$timer);
            $d547ae2449ccd11b$var$handlePageChange({
                url: $d547ae2449ccd11b$var$currentUrl,
                delay: delay,
                theme: theme,
                lang: lang
            });
        }
    }, 1000);
}
$d547ae2449ccd11b$var$checkIfShown();
/*
 * Returns 1 or 2
 * 1: Popup Variante A "grosses Pop Up"
 * 2: Popup Variante B "kleines Pop Up"
 */ function $d547ae2449ccd11b$var$getVariant(theme) {
    if (!$d547ae2449ccd11b$var$isMobile() || theme === "melectronics") return 1;
    else return 2;
}
function $d547ae2449ccd11b$var$isMobile() {
    var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return vw <= 640;
}
function $d547ae2449ccd11b$var$isThrottled() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2f23a94a28b6e759$exports))).get($d547ae2449ccd11b$var$THROTTLED_COOKIE_NAME) === "true";
}
function $d547ae2449ccd11b$var$updatePopupPrimaryButtonShopUrl() {
    var popupPrimaryButton = document.querySelector(".js-beratungshero-popup-primary-button");
    if (popupPrimaryButton) {
        var currentLink = popupPrimaryButton.getAttribute("href");
        var newLink = currentLink.replace(/&url=.*&consultantId=/, "&url=".concat($d547ae2449ccd11b$var$getShopUrl(), "&consultantId="));
        popupPrimaryButton.setAttribute("href", newLink.replace(/&richrelevanceFeed=.*/, ""));
    }
}
function $d547ae2449ccd11b$var$updateRichrelevanceFeed() {
    var richrelevanceFeed = (0, $68bc11eae8fdf90e$export$b33daf2836bb52dc)();
    if (richrelevanceFeed) {
        var popupPrimaryButton = document.querySelector(".js-beratungshero-popup-primary-button");
        if (popupPrimaryButton) {
            var currentLink = popupPrimaryButton.getAttribute("href");
            var newLink;
            if (currentLink.includes("&richrelevanceFeed=")) newLink = currentLink.replace(/&richrelevanceFeed=.*/, "&richrelevanceFeed=".concat(richrelevanceFeed));
            else newLink = "".concat(currentLink, "&richrelevanceFeed=").concat(richrelevanceFeed);
            popupPrimaryButton.setAttribute("href", newLink);
        }
    }
}
function $d547ae2449ccd11b$var$getShopUrl() {
    var shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) shopUrl = "https://www.klubschule.ch/Services/Beratung-und-Kontakt/Live-Videoberatung"; //https://qual-www.sportx.ch/de/p/405750100000/diener";
    return shopUrl;
}
function $d547ae2449ccd11b$var$logOptimizeEvent(eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName
    });
}
function $d547ae2449ccd11b$var$showMiocolorWidget(url, theme, lang) {
    return theme === "doitgarden" && (url.match(/\/(miocolor)/) || url.match(/\/(elle-decoration)/) || url.match(/\/(malen)/) || url.match(/\/(schoener-wohnen)/) || url.match(/\/(dupli-color)/) || url.match(/\/(d-c-fix)/) || url.match(/\/(color-expert)/) || url.match(/\/(produktfinder-malen)/) || url.match(/\/(farbmisch-service)/) || url.match(/q=farbe/) || url.match(/q=wand%20farben/) || url.match(/malen/) || url.match(/q=lack/) || (0, $e62392e7a88672ed$export$92413a7c60d15e8a)(url, "malen")) && lang === "de";
}
function $d547ae2449ccd11b$var$showSportxTouchpoints(theme, lang) {
    if (!document.querySelector(".js__beratungshero--sticker.beratungshero--sticker")) {
        var containerSticker = document.querySelector("#migros-beratungshero");
        if (containerSticker) {
            containerSticker.style.position = "relative";
            window.BH.renderSticker(containerSticker, {
                tenant: theme,
                lang: lang
            });
        }
    }
    if (!document.querySelector(".beratungshero--root.p-product-detail--item.p-product-detail--item__details.detail-navigation-section")) {
        var containerBanner = document.querySelector("#accordion-wrapper>div:nth-child(5)");
        if (containerBanner) window.BH.renderBanner(containerBanner, {
            tenant: theme,
            lang: lang
        });
    }
}
(function() {
    var match = document.location.href.split("#")[0].match(/(bikeworld|doitgarden|micasa|melectronics|sportx).ch\/(de|fr|it)/);
    if (!match) return;
    var _match = (0, $595c5a81428bb48a$export$71511d61b312f219)(match, 3), theme = _match[1], lang = _match[2];
    if (theme === "sportx") {
        var previousUrl = "";
        var observer = new MutationObserver(function(mutations) {
            if (location.href !== previousUrl) {
                previousUrl = location.href;
                $d547ae2449ccd11b$var$showSportxTouchpoints(theme, lang);
            }
        });
        var config = {
            subtree: true,
            childList: true
        };
        observer.observe(document, config);
    }
})();

})();
//# sourceMappingURL=index.906a9072.js.map
